const textDefaults = {
	'EN': {
		'yesLabel': 'Yes',
		'noLabel': 'No',
		'intro': 'We need to collect your safety certificates to ensure compliance with site requirements. This process will help us verify your qualifications and ensure you can safely perform work on site.',
		'userDetailsTitle': 'Please provide your details',
		'lblFirstName': 'First Name',
		'lblLastName': 'Last Name',
		'lblDOB': 'Date Of Birth',
		'lblVAT': 'VAT number',
		'processingText': 'Searching for your safety certificates...',
		'confirmationTitle': 'Review your safety certificates',
		'confirmationRequiredSubtitle': 'The following types are required: ',
		'confirmationRequiredSatisfied': 'All required documents are provided',
		'summaryTextAllComplete': 'All required certificates are available.',
		'oneOfFollowingLabel': 'Upload at least one of the following:',
		'confirmationOptionalSubtitle': 'The following types are optional: ',
		'foundCertificatesTitle': 'Found Certificates',
		'foundCertificatesSubtitle': 'We found the following certificates. Please deselect any that are not relevant or belong to another person:',
		'uploadDocumentsTitle': 'Upload Documents',
		'uploadedDocumentsSubtitle': 'Review your uploaded documents and remove any that are not relevant:',
		'noDocumentsCheckbox': 'I confirm that I want to continue without submitting any safety certificates and understand that this may impact my ability to perform work on site.',
		'thankYouTitle': 'Thank you for your submission',
		'thankYouText': 'Your safety certificates have been submitted and are now subject to review. We will contact you if any additional information is required.',
		'removeDocument': 'Remove',
		'certificateNumber': 'Certificate Number',
		'certificateType': 'Certificate Type',
		'certificateIssuer': 'Issuer',
		'validUntil': 'Valid Until',
		'processingFeedback': 'Processing feedback',
		'noCertificatesFoundTitle': 'No Certificates Found',
		'noCertificatesFoundMessage': 'We couldn\'t find any safety certificates automatically. Please upload your certificates manually using the upload section below.',
		'gapAnalysisCheckbox': 'I have no certificates, but want to perform a Gap analysis',
		'gapAnalysisUploadTitle': 'Upload Gap Analysis',
		'gapAnalysisUploadSubtitle': 'Please upload your completed Gap analysis document.',
		'gapAnalysisTemplateLink': 'Download Gap analysis template',
		'uploadDocument': 'Upload Document',
		'dropFileHere': 'Drop file here...',
		'dragDropFile': 'Drag and drop a file here, or click to select a file',
		'uploading': 'Uploading',
		'uploadFailed': 'Upload failed',
		'dismiss': 'Dismiss',
		'requiredDocumentsUploaded': 'Required Documents',
		'optionalDocumentsUploaded': 'Optional Documents',
		'otherDocumentsUploaded': 'Other Documents',
		'recognizedAs': 'Recognized as',
		'aiProcessingSubtext': 'AI is processing your document',
		'uploadTitle': 'Validation & Gap Analysis',
		'analysisCompleteLabel': 'Analysis Complete',
		'summaryText': 'You need {total}. {missing} currently missing from your profile.',
		'verifiedLabel': 'VERIFIED',
		'actionRequiredLabel': 'ACTION REQUIRED',
		'uploadDocumentsSubtitle': 'Drag and drop files here or click to select. The system will automatically detect the document type.',
		'noDocumentsNeededTitle': 'No Documents Required',
		'noDocumentsNeededMessage': 'Based on your answers, no additional safety certificates are required for this work type.',
		'missingCertificationsAcknowledgment': 'I acknowledge the missing certifications and confirm I have valid temporary paper copies to present on-site.',
		'certificateSingular': 'certificate',
		'certificatePlural': 'certificates',
		'missingCountSingular': 'is',
		'missingCountPlural': 'are',
		'expiresLabel': 'EXPIRES',
		'orSeparator': ' or '
	},
	'FR': {
		'yesLabel': 'Oui',
		'noLabel': 'Non',
		'intro': 'Nous devons collecter vos certificats de sécurité pour assurer la conformité aux exigences du site. Ce processus nous aidera à vérifier vos qualifications et à nous assurer que vous pouvez effectuer le travail en toute sécurité sur le site.',
		'userDetailsTitle': 'Veuillez fournir vos coordonnées',
		'lblFirstName': 'Prénom',
		'lblLastName': 'Nom de famille',
		'lblDOB': 'Date de naissance',
		'lblVAT': 'Numéro de TVA',
		'processingText': 'Recherche de vos certificats de sécurité...',
		'confirmationTitle': 'Examinez vos certificats de sécurité',
		'confirmationRequiredSubtitle': 'Les types suivants sont requis : ',
		'confirmationRequiredSatisfied': 'Tous les documents requis sont fournis',
		'summaryTextAllComplete': 'Tous les certificats requis sont disponibles.',
		'oneOfFollowingLabel': 'Téléchargez au moins l\'un des éléments suivants :',
		'confirmationOptionalSubtitle': 'Les types suivants sont facultatifs : ',
		'foundCertificatesTitle': 'Certificats trouvés',
		'foundCertificatesSubtitle': 'Nous avons trouvé les certificats suivants. Veuillez désélectionner ceux qui ne sont pas pertinents ou qui appartiennent à une autre personne :',
		'uploadDocumentsTitle': 'Télécharger des documents',
		'uploadedDocumentsSubtitle': 'Examinez vos documents téléchargés et supprimez ceux qui ne sont pas pertinents :',
		'noDocumentsCheckbox': 'Je confirme que je souhaite continuer sans soumettre de certificats de sécurité et comprends que cela peut affecter ma capacité à effectuer des travaux sur le site.',
		'thankYouTitle': 'Merci pour votre soumission',
		'thankYouText': 'Vos certificats de sécurité ont été soumis et sont maintenant en cours d\'examen. Nous vous contacterons si des informations supplémentaires sont requises.',
		'removeDocument': 'Supprimer',
		'certificateNumber': 'Numéro de certificat',
		'certificateType': 'Type de certificat',
		'certificateIssuer': 'Émetteur',
		'validUntil': 'Valide jusqu\'au',
		'processingFeedback': 'Commentaires de traitement',
		'noCertificatesFoundTitle': 'Aucun certificat trouvé',
		'noCertificatesFoundMessage': 'Nous n\'avons pas pu trouver automatiquement de certificats de sécurité. Veuillez télécharger vos certificats manuellement en utilisant la section de téléchargement ci-dessous.',
		'gapAnalysisCheckbox': 'Je n\'ai pas de certificats, mais je souhaite effectuer une analyse des écarts',
		'gapAnalysisUploadTitle': 'Télécharger l\'analyse des écarts',
		'gapAnalysisUploadSubtitle': 'Veuillez télécharger votre document d\'analyse des écarts complété.',
		'gapAnalysisTemplateLink': 'Télécharger le modèle d\'analyse des écarts',
		'uploadDocument': 'Télécharger un document',
		'dropFileHere': 'Déposez le fichier ici...',
		'dragDropFile': 'Glissez-déposez un fichier ici ou cliquez pour sélectionner un fichier',
		'uploading': 'Téléchargement en cours',
		'uploadFailed': 'Échec du téléchargement',
		'dismiss': 'Ignorer',
		'requiredDocumentsUploaded': 'Documents requis',
		'optionalDocumentsUploaded': 'Documents optionnels',
		'otherDocumentsUploaded': 'Autres documents',
		'recognizedAs': 'Reconnu comme',
		'aiProcessingSubtext': 'L\'IA traite votre document',
		'uploadTitle': 'Validation et analyse des écarts',
		'analysisCompleteLabel': 'Analyse terminée',
		'summaryText': 'Vous avez besoin de {total}. {missing} actuellement manquant(s) dans votre profil.',
		'verifiedLabel': 'VÉRIFIÉ',
		'actionRequiredLabel': 'ACTION REQUISE',
		'uploadDocumentsSubtitle': 'Glissez-déposez des fichiers ici ou cliquez pour sélectionner. Le système détectera automatiquement le type de document.',
		'noDocumentsNeededTitle': 'Aucun document requis',
		'noDocumentsNeededMessage': 'Selon vos réponses, aucun certificat de sécurité supplémentaire n\'est requis pour ce type de travail.',
		'missingCertificationsAcknowledgment': 'Je reconnais les certifications manquantes et confirme que je dispose de copies papier temporaires valides à présenter sur site.',
		'certificateSingular': 'certificat',
		'certificatePlural': 'certificats',
		'missingCountSingular': 'est',
		'missingCountPlural': 'sont',
		'expiresLabel': 'EXPIRE LE',
		'orSeparator': ' ou '
	},
	'DE': {
		'yesLabel': 'Ja',
		'noLabel': 'Nein',
		'intro': 'Wir müssen Ihre Sicherheitszertifikate sammeln, um die Einhaltung der Standortanforderungen sicherzustellen. Dieser Prozess hilft uns, Ihre Qualifikationen zu überprüfen und sicherzustellen, dass Sie sicher am Standort arbeiten können.',
		'userDetailsTitle': 'Bitte geben Sie Ihre Daten an',
		'lblFirstName': 'Vorname',
		'lblLastName': 'Nachname',
		'lblDOB': 'Geburtsdatum',
		'lblVAT': 'Umsatzsteuer-Identifikationsnummer',
		'processingText': 'Suche nach Ihren Sicherheitszertifikaten...',
		'confirmationTitle': 'Überprüfen Sie Ihre Sicherheitszertifikate',
		'confirmationRequiredSubtitle': 'Die folgenden Typen sind erforderlich: ',
		'confirmationRequiredSatisfied': 'Alle erforderlichen Dokumente sind vorhanden',
		'summaryTextAllComplete': 'Alle erforderlichen Zertifikate sind verfügbar.',
		'oneOfFollowingLabel': 'Laden Sie mindestens eines der folgenden hoch:',
		'confirmationOptionalSubtitle': 'Die folgenden Typen sind optional: ',
		'foundCertificatesTitle': 'Gefundene Zertifikate',
		'foundCertificatesSubtitle': 'Wir haben die folgenden Zertifikate gefunden. Bitte deaktivieren Sie alle, die nicht relevant sind oder einer anderen Person gehören:',
		'uploadDocumentsTitle': 'Dokumente hochladen',
		'uploadedDocumentsSubtitle': 'Überprüfen Sie Ihre hochgeladenen Dokumente und entfernen Sie alle, die nicht relevant sind:',
		'noDocumentsCheckbox': 'Ich bestätige, dass ich ohne Einreichung von Sicherheitszertifikaten fortfahren möchte und verstehe, dass dies meine Fähigkeit zur Ausführung von Arbeiten am Standort beeinträchtigen kann.',
		'thankYouTitle': 'Vielen Dank für Ihre Einreichung',
		'thankYouText': 'Ihre Sicherheitszertifikate wurden eingereicht und werden nun überprüft. Wir werden Sie kontaktieren, wenn zusätzliche Informationen erforderlich sind.',
		'removeDocument': 'Entfernen',
		'certificateNumber': 'Zertifikatsnummer',
		'certificateType': 'Zertifikatstyp',
		'certificateIssuer': 'Aussteller',
		'validUntil': 'Gültig bis',
		'processingFeedback': 'Verarbeitungsfeedback',
		'noCertificatesFoundTitle': 'Keine Zertifikate gefunden',
		'noCertificatesFoundMessage': 'Wir konnten keine Sicherheitszertifikate automatisch finden. Bitte laden Sie Ihre Zertifikate manuell über den Upload-Bereich unten hoch.',
		'gapAnalysisCheckbox': 'Ich habe keine Zertifikate, möchte aber eine Lückenanalyse durchführen',
		'gapAnalysisUploadTitle': 'Lückenanalyse hochladen',
		'gapAnalysisUploadSubtitle': 'Bitte laden Sie Ihr ausgefülltes Lückenanalyse-Dokument hoch.',
		'gapAnalysisTemplateLink': 'Lückenanalyse-Vorlage herunterladen',
		'uploadDocument': 'Dokument hochladen',
		'dropFileHere': 'Datei hier ablegen...',
		'dragDropFile': 'Datei hierher ziehen und ablegen oder klicken, um eine Datei auszuwählen',
		'uploading': 'Wird hochgeladen',
		'uploadFailed': 'Upload fehlgeschlagen',
		'dismiss': 'Verwerfen',
		'requiredDocumentsUploaded': 'Erforderliche Dokumente',
		'optionalDocumentsUploaded': 'Optionale Dokumente',
		'otherDocumentsUploaded': 'Weitere Dokumente',
		'recognizedAs': 'Erkannt als',
		'aiProcessingSubtext': 'KI verarbeitet Ihr Dokument',
		'uploadTitle': 'Validierung & Lückenanalyse',
		'analysisCompleteLabel': 'Analyse abgeschlossen',
		'summaryText': 'Sie benötigen {total}. {missing} fehlt/fehlen derzeit in Ihrem Profil.',
		'verifiedLabel': 'VERIFIZIERT',
		'actionRequiredLabel': 'AKTION ERFORDERLICH',
		'uploadDocumentsSubtitle': 'Dateien hier per Drag & Drop ablegen oder klicken zum Auswählen. Das System erkennt den Dokumenttyp automatisch.',
		'noDocumentsNeededTitle': 'Keine Dokumente erforderlich',
		'noDocumentsNeededMessage': 'Basierend auf Ihren Antworten sind keine zusätzlichen Sicherheitszertifikate für diesen Arbeitstyp erforderlich.',
		'missingCertificationsAcknowledgment': 'Ich bestätige die fehlenden Zertifizierungen und bestätige, dass ich gültige temporäre Papierkopien zur Vorlage vor Ort habe.',
		'certificateSingular': 'Zertifikat',
		'certificatePlural': 'Zertifikate',
		'missingCountSingular': 'fehlt',
		'missingCountPlural': 'fehlen',
		'expiresLabel': 'LÄUFT AB',
		'orSeparator': ' oder '
	},
	'NL': {
		'yesLabel': 'Ja',
		'noLabel': 'Nee',
		'intro': 'We moeten uw veiligheidscertificaten verzamelen om te zorgen voor naleving van de site-eisen. Dit proces helpt ons uw kwalificaties te verifiëren en ervoor te zorgen dat u veilig werk op de site kunt uitvoeren.',
		'userDetailsTitle': 'Geef uw gegevens op',
		'lblFirstName': 'Voornaam',
		'lblLastName': 'Achternaam',
		'lblDOB': 'Geboortedatum',
		'lblVAT': 'BTW-nummer',
		'processingText': 'Zoeken naar uw veiligheidscertificaten...',
		'confirmationTitle': 'Bekijk uw veiligheidscertificaten',
		'confirmationRequiredSubtitle': 'De volgende types zijn vereist: ',
		'confirmationRequiredSatisfied': 'Alle vereiste documenten zijn verstrekt',
		'confirmationOptionalSubtitle': 'De volgende types zijn optioneel: ',
		'foundCertificatesTitle': 'Gevonden certificaten',
		'foundCertificatesSubtitle': 'We hebben de volgende certificaten gevonden. Deselecteer degenen die niet relevant zijn of van een andere persoon zijn:',
		'uploadDocumentsTitle': 'Documenten uploaden',
		'uploadedDocumentsSubtitle': 'Bekijk uw geüploade documenten en verwijder degenen die niet relevant zijn:',
		'noDocumentsCheckbox': 'Ik bevestig dat ik wil doorgaan zonder veiligheidscertificaten in te dienen en begrijp dat dit mijn vermogen om werk op de site uit te voeren kan beïnvloeden.',
		'thankYouTitle': 'Bedankt voor uw inzending',
		'thankYouText': 'Uw veiligheidscertificaten zijn ingediend en worden nu beoordeeld. We zullen contact met u opnemen als er aanvullende informatie nodig is.',
		'removeDocument': 'Verwijderen',
		'certificateNumber': 'Certificaatnummer',
		'certificateType': 'Certificaattype',
		'certificateIssuer': 'Uitgever',
		'validUntil': 'Geldig tot',
		'processingFeedback': 'Verwerkingsfeedback',
		'noCertificatesFoundTitle': 'Geen certificaten gevonden',
		'noCertificatesFoundMessage': 'We konden geen veiligheidscertificaten automatisch vinden. Upload uw certificaten handmatig via het upload-gedeelte hieronder.',
		'gapAnalysisCheckbox': 'Ik heb geen certificaten, maar wil een Gap-analyse uitvoeren',
		'gapAnalysisUploadTitle': 'Gap-analyse uploaden',
		'gapAnalysisUploadSubtitle': 'Upload uw ingevulde Gap-analyse document.',
		'gapAnalysisTemplateLink': 'Download Gap-analyse sjabloon',
		'uploadDocument': 'Document uploaden',
		'dropFileHere': 'Laat bestand hier los...',
		'dragDropFile': 'Sleep een bestand hierheen of klik om een bestand te selecteren',
		'uploading': 'Uploaden.',
		'uploadFailed': 'Upload mislukt',
		'dismiss': 'Sluiten',
		'requiredDocumentsUploaded': 'Verplichte documenten',
		'optionalDocumentsUploaded': 'Optionele documenten',
		'otherDocumentsUploaded': 'Overige documenten',
		'recognizedAs': 'Herkend als',
		'aiProcessingSubtext': 'AI verwerkt uw document',
		'uploadTitle': 'Validatie & hiatenanalyse',
		'analysisCompleteLabel': 'Analyse voltooid',
		'summaryText': 'U heeft {total} nodig. {missing} ontbreekt/ontbreken momenteel in uw profiel.',
		'verifiedLabel': 'GEVERIFIEERD',
		'actionRequiredLabel': 'ACTIE VEREIST',
		'uploadDocumentsSubtitle': 'Sleep bestanden hierheen of klik om te selecteren. Het systeem detecteert automatisch het documenttype.',
		'noDocumentsNeededTitle': 'Geen documenten vereist',
		'noDocumentsNeededMessage': 'Op basis van uw antwoorden zijn er geen aanvullende veiligheidscertificaten vereist voor dit werktype.',
		'missingCertificationsAcknowledgment': 'Ik erken de ontbrekende certificeringen en bevestig dat ik geldige tijdelijke papieren kopieën heb om ter plaatse te tonen.',
		'summaryTextAllComplete': 'Alle vereiste certificaten zijn beschikbaar.',
		'oneOfFollowingLabel': 'Upload ten minste één van de volgende:',
		'certificateSingular': 'certificaat',
		'certificatePlural': 'certificaten',
		'missingCountSingular': 'ontbreekt',
		'missingCountPlural': 'ontbreken',
		'expiresLabel': 'VERLOOPT',
		'orSeparator': ' of '
	},
	'PL': {
		'yesLabel': 'Tak',
		'noLabel': 'Nie',
		'intro': 'Musimy zebrać Twoje certyfikaty bezpieczeństwa, aby zapewnić zgodność z wymaganiami miejsca pracy. Ten proces pomoże nam zweryfikować Twoje kwalifikacje i zapewnić, że możesz bezpiecznie wykonywać pracę na miejscu.',
		'userDetailsTitle': 'Proszę podać swoje dane',
		'lblFirstName': 'Imię',
		'lblLastName': 'Nazwisko',
		'lblDOB': 'Data urodzenia',
		'lblVAT': 'Numer VAT',
		'processingText': 'Wyszukiwanie Twoich certyfikatów bezpieczeństwa...',
		'confirmationTitle': 'Przejrzyj swoje certyfikaty bezpieczeństwa',
		'confirmationRequiredSubtitle': 'Wymagane są następujące typy: ',
		'confirmationRequiredSatisfied': 'Wszystkie wymagane dokumenty zostały dostarczone',
		'confirmationOptionalSubtitle': 'Następujące typy są opcjonalne: ',
		'foundCertificatesTitle': 'Znalezione certyfikaty',
		'foundCertificatesSubtitle': 'Znaleźliśmy następujące certyfikaty. Proszę odznaczyć te, które nie są istotne lub należą do innej osoby:',
		'uploadDocumentsTitle': 'Prześlij dokumenty',
		'uploadedDocumentsSubtitle': 'Przejrzyj swoje przesłane dokumenty i usuń te, które nie są istotne:',
		'noDocumentsCheckbox': 'Potwierdzam, że chcę kontynuować bez przesyłania certyfikatów bezpieczeństwa i rozumiem, że może to wpłynąć na moją zdolność do wykonywania pracy na miejscu.',
		'thankYouTitle': 'Dziękujemy za przesłanie',
		'thankYouText': 'Twoje certyfikaty bezpieczeństwa zostały przesłane i są teraz poddawane przeglądowi. Skontaktujemy się z Tobą, jeśli będą potrzebne dodatkowe informacje.',
		'removeDocument': 'Usuń',
		'certificateNumber': 'Numer certyfikatu',
		'certificateType': 'Typ certyfikatu',
		'certificateIssuer': 'Wydawca',
		'validUntil': 'Ważny do',
		'processingFeedback': 'Informacje zwrotne o przetwarzaniu',
		'noCertificatesFoundTitle': 'Nie znaleziono certyfikatów',
		'noCertificatesFoundMessage': 'Nie mogliśmy automatycznie znaleźć żadnych certyfikatów bezpieczeństwa. Proszę przesłać swoje certyfikaty ręcznie, korzystając z sekcji przesyłania poniżej.',
		'gapAnalysisCheckbox': 'Nie mam certyfikatów, ale chcę przeprowadzić analizę luk',
		'gapAnalysisUploadTitle': 'Prześlij analizę luk',
		'gapAnalysisUploadSubtitle': 'Proszę przesłać wypełniony dokument analizy luk.',
		'gapAnalysisTemplateLink': 'Pobierz szablon analizy luk',
		'uploadDocument': 'Prześlij dokument',
		'dropFileHere': 'Upuść plik tutaj...',
		'dragDropFile': 'Przeciągnij i upuść plik tutaj lub kliknij, aby wybrać plik',
		'uploading': 'Przesyłanie',
		'uploadFailed': 'Przesyłanie nie powiodło się',
		'dismiss': 'Odrzuć',
		'requiredDocumentsUploaded': 'Wymagane dokumenty',
		'optionalDocumentsUploaded': 'Opcjonalne dokumenty',
		'otherDocumentsUploaded': 'Inne dokumenty',
		'recognizedAs': 'Rozpoznano jako',
		'aiProcessingSubtext': 'AI przetwarza Twój dokument',
		'uploadTitle': 'Walidacja i analiza luk',
		'analysisCompleteLabel': 'Analiza zakończona',
		'summaryText': 'Potrzebujesz {total}. {missing} brakuje obecnie w Twoim profilu.',
		'verifiedLabel': 'ZWERYFIKOWANY',
		'actionRequiredLabel': 'WYMAGANA AKCJA',
		'uploadDocumentsSubtitle': 'Przeciągnij i upuść pliki tutaj lub kliknij, aby wybrać. System automatycznie wykryje typ dokumentu.',
		'noDocumentsNeededTitle': 'Dokumenty nie są wymagane',
		'noDocumentsNeededMessage': 'Na podstawie Twoich odpowiedzi żadne dodatkowe certyfikaty bezpieczeństwa nie są wymagane dla tego typu pracy.',
		'missingCertificationsAcknowledgment': 'Potwierdzam brakujące certyfikaty i potwierdzam, że posiadam ważne tymczasowe kopie papierowe do okazania na miejscu.',
		'summaryTextAllComplete': 'Wszystkie wymagane certyfikaty są dostępne.',
		'oneOfFollowingLabel': 'Prześlij co najmniej jeden z poniższych:',
		'certificateSingular': 'certyfikat',
		'certificatePlural': 'certyfikatów',
		'missingCountSingular': 'brakuje',
		'missingCountPlural': 'brakuje',
		'expiresLabel': 'WYGASA',
		'orSeparator': ' lub '
	},
	'BG': {
		'yesLabel': 'Да',
		'noLabel': 'Не',
		'intro': 'Трябва да съберем вашите сертификати за безопасност, за да гарантираме съответствие с изискванията на обекта. Този процес ще ни помогне да проверим вашите квалификации и да гарантираме, че можете безопасно да извършвате работа на обекта.',
		'userDetailsTitle': 'Моля, предоставете вашите данни',
		'lblFirstName': 'Първо име',
		'lblLastName': 'Фамилия',
		'lblDOB': 'Дата на раждане',
		'lblVAT': 'ДДС номер',
		'processingText': 'Търсене на вашите сертификати за безопасност...',
		'confirmationTitle': 'Прегледайте вашите сертификати за безопасност',
		'confirmationRequiredSubtitle': 'Следните типове са задължителни: ',
		'confirmationRequiredSatisfied': 'Всички задължителни документи са предоставени',
		'confirmationOptionalSubtitle': 'Следните типове са опционални: ',
		'foundCertificatesTitle': 'Намерени сертификати',
		'foundCertificatesSubtitle': 'Намерихме следните сертификати. Моля, отменете избора на тези, които не са релевантни или принадлежат на друго лице:',
		'uploadDocumentsTitle': 'Качване на документи',
		'uploadedDocumentsSubtitle': 'Прегледайте вашите качени документи и премахнете тези, които не са релевантни:',
		'noDocumentsCheckbox': 'Потвърждавам, че искам да продължа без да подавам сертификати за безопасност и разбирам, че това може да повлияе на способността ми да извършвам работа на обекта.',
		'thankYouTitle': 'Благодарим ви за подаването',
		'thankYouText': 'Вашите сертификати за безопасност са подадени и сега са предмет на преглед. Ще се свържем с вас, ако е необходима допълнителна информация.',
		'removeDocument': 'Премахни',
		'certificateNumber': 'Номер на сертификат',
		'certificateType': 'Тип сертификат',
		'certificateIssuer': 'Издател',
		'validUntil': 'Валиден до',
		'processingFeedback': 'Обратна връзка за обработка',
		'noCertificatesFoundTitle': 'Не са намерени сертификати',
		'noCertificatesFoundMessage': 'Не можахме автоматично да намерим сертификати за безопасност. Моля, качете вашите сертификати ръчно, като използвате секцията за качване по-долу.',
		'gapAnalysisCheckbox': 'Нямам сертификати, но искам да извърша анализ на пропуски',
		'gapAnalysisUploadTitle': 'Качване на анализ на пропуски',
		'gapAnalysisUploadSubtitle': 'Моля, качете вашия попълнен документ за анализ на пропуски.',
		'gapAnalysisTemplateLink': 'Изтегли шаблон за анализ на пропуски',
		'uploadDocument': 'Качи документ',
		'dropFileHere': 'Пуснете файла тук...',
		'dragDropFile': 'Плъзнете и пуснете файл тук или кликнете, за да изберете файл',
		'uploading': 'Качване',
		'uploadFailed': 'Качването не бе успешно',
		'dismiss': 'Отхвърли',
		'requiredDocumentsUploaded': 'Задължителни документи',
		'optionalDocumentsUploaded': 'Опционални документи',
		'otherDocumentsUploaded': 'Други документи',
		'recognizedAs': 'Разпознат като',
		'aiProcessingSubtext': 'ИИ обработва вашия документ',
		'uploadTitle': 'Валидация и анализ на пропуски',
		'analysisCompleteLabel': 'Анализът е завършен',
		'summaryText': 'Имате нужда от {total}. {missing} липсва/липсват в профила ви.',
		'verifiedLabel': 'ПРОВЕРЕН',
		'actionRequiredLabel': 'ИЗИСКВА СЕ ДЕЙСТВИЕ',
		'uploadDocumentsSubtitle': 'Плъзнете и пуснете файлове тук или кликнете, за да изберете. Системата ще разпознае автоматично типа на документа.',
		'noDocumentsNeededTitle': 'Не се изискват документи',
		'noDocumentsNeededMessage': 'Въз основа на вашите отговори не се изискват допълнителни сертификати за безопасност за този тип работа.',
		'missingCertificationsAcknowledgment': 'Потвърждавам липсващите сертификати и потвърждавам, че разполагам с валидни временни хартиени копия за представяне на обекта.',
		'summaryTextAllComplete': 'Всички необходими сертификати са налични.',
		'oneOfFollowingLabel': 'Качете поне един от следните:',
		'certificateSingular': 'сертификат',
		'certificatePlural': 'сертификата',
		'missingCountSingular': 'липсва',
		'missingCountPlural': 'липсват',
		'expiresLabel': 'ИЗТИЧА',
		'orSeparator': ' или '
	},
	'CS': {
		'yesLabel': 'Ano',
		'noLabel': 'Ne',
		'intro': 'Musíme shromáždit vaše bezpečnostní certifikáty, abychom zajistili soulad s požadavky na místě. Tento proces nám pomůže ověřit vaše kvalifikace a zajistit, že můžete bezpečně vykonávat práci na místě.',
		'userDetailsTitle': 'Uveďte prosím své údaje',
		'lblFirstName': 'Jméno',
		'lblLastName': 'Příjmení',
		'lblDOB': 'Datum narození',
		'lblVAT': 'DIČ',
		'processingText': 'Vyhledávání vašich bezpečnostních certifikátů...',
		'confirmationTitle': 'Zkontrolujte své bezpečnostní certifikáty',
		'confirmationRequiredSubtitle': 'Následující typy jsou povinné: ',
		'confirmationRequiredSatisfied': 'Všechny požadované dokumenty jsou poskytnuty',
		'confirmationOptionalSubtitle': 'Následující typy jsou volitelné: ',
		'foundCertificatesTitle': 'Nalezené certifikáty',
		'foundCertificatesSubtitle': 'Našli jsme následující certifikáty. Prosím zrušte výběr těch, které nejsou relevantní nebo patří jiné osobě:',
		'uploadDocumentsTitle': 'Nahrát dokumenty',
		'uploadedDocumentsSubtitle': 'Zkontrolujte své nahrané dokumenty a odstraňte ty, které nejsou relevantní:',
		'noDocumentsCheckbox': 'Potvrzuji, že chci pokračovat bez předložení bezpečnostních certifikátů a chápu, že to může ovlivnit mou schopnost vykonávat práci na místě.',
		'thankYouTitle': 'Děkujeme za vaše podání',
		'thankYouText': 'Vaše bezpečnostní certifikáty byly předloženy a jsou nyní předmětem kontroly. Kontaktujeme vás, pokud budou požadovány další informace.',
		'removeDocument': 'Odstranit',
		'certificateNumber': 'Číslo certifikátu',
		'certificateType': 'Typ certifikátu',
		'certificateIssuer': 'Vydavatel',
		'validUntil': 'Platný do',
		'processingFeedback': 'Zpětná vazba zpracování',
		'noCertificatesFoundTitle': 'Nebyly nalezeny žádné certifikáty',
		'noCertificatesFoundMessage': 'Nemohli jsme automaticky najít žádné bezpečnostní certifikáty. Nahrajte prosím své certifikáty ručně pomocí sekce pro nahrávání níže.',
		'gapAnalysisCheckbox': 'Nemám žádné certifikáty, ale chci provést analýzu mezer',
		'gapAnalysisUploadTitle': 'Nahrát analýzu mezer',
		'gapAnalysisUploadSubtitle': 'Nahrajte prosím svůj vyplněný dokument analýzy mezer.',
		'gapAnalysisTemplateLink': 'Stáhnout šablonu analýzy mezer',
		'uploadDocument': 'Nahrát dokument',
		'dropFileHere': 'Přetáhněte soubor sem...',
		'dragDropFile': 'Přetáhněte a pusťte soubor sem nebo klikněte pro výběr souboru',
		'uploading': 'Nahrávání',
		'uploadFailed': 'Nahrávání selhalo',
		'dismiss': 'Zavřít',
		'requiredDocumentsUploaded': 'Povinné dokumenty',
		'optionalDocumentsUploaded': 'Volitelné dokumenty',
		'otherDocumentsUploaded': 'Jiné dokumenty',
		'recognizedAs': 'Rozpoznáno jako',
		'aiProcessingSubtext': 'AI zpracovává váš dokument',
		'uploadTitle': 'Validace a analýza mezer',
		'analysisCompleteLabel': 'Analýza dokončena',
		'summaryText': 'Potřebujete {total}. {missing} v současnosti chybí ve vašem profilu.',
		'verifiedLabel': 'OVĚŘENO',
		'actionRequiredLabel': 'VYŽADOVÁNA AKCE',
		'uploadDocumentsSubtitle': 'Přetáhněte soubory sem nebo klikněte pro výběr. Systém automaticky rozpozná typ dokumentu.',
		'noDocumentsNeededTitle': 'Nejsou vyžadovány žádné dokumenty',
		'noDocumentsNeededMessage': 'Na základě vašich odpovědí nejsou pro tento typ práce vyžadovány žádné další bezpečnostní certifikáty.',
		'missingCertificationsAcknowledgment': 'Potvrzuji chybějící certifikáty a potvrzuji, že mám platné dočasné papírové kopie k předložení na místě.',
		'summaryTextAllComplete': 'Všechny požadované certifikáty jsou dostupné.',
		'oneOfFollowingLabel': 'Nahrajte alespoň jeden z následujících:',
		'certificateSingular': 'certifikát',
		'certificatePlural': 'certifikátů',
		'missingCountSingular': 'chybí',
		'missingCountPlural': 'chybí',
		'expiresLabel': 'PLATNOST DO',
		'orSeparator': ' nebo '
	},
	'DA': {
		'yesLabel': 'Ja',
		'noLabel': 'Nej',
		'intro': 'Vi skal indsamle jeres sikkerhedscertifikater for at sikre overholdelse af stedets krav. Denne proces vil hjælpe os med at verificere jeres kvalifikationer og sikre, at I sikkert kan udføre arbejde på stedet.',
		'userDetailsTitle': 'Angiv venligst jeres oplysninger',
		'lblFirstName': 'Fornavn',
		'lblLastName': 'Efternavn',
		'lblDOB': 'Fødselsdato',
		'lblVAT': 'CVR-nummer',
		'processingText': 'Søger efter jeres sikkerhedscertifikater...',
		'confirmationTitle': 'Gennemgå jeres sikkerhedscertifikater',
		'confirmationRequiredSubtitle': 'Følgende typer er påkrævet: ',
		'confirmationRequiredSatisfied': 'Alle påkrævede dokumenter er leveret',
		'confirmationOptionalSubtitle': 'Følgende typer er valgfrie: ',
		'foundCertificatesTitle': 'Fundne certifikater',
		'foundCertificatesSubtitle': 'Vi har fundet følgende certifikater. Fjern venligst markeringen af dem, der ikke er relevante eller tilhører en anden person:',
		'uploadDocumentsTitle': 'Upload dokumenter',
		'uploadedDocumentsSubtitle': 'Gennemgå jeres uploadede dokumenter og fjern dem, der ikke er relevante:',
		'noDocumentsCheckbox': 'Jeg bekræfter, at jeg ønsker at fortsætte uden at indsende sikkerhedscertifikater og forstår, at dette kan påvirke min evne til at udføre arbejde på stedet.',
		'thankYouTitle': 'Tak for jeres indsendelse',
		'thankYouText': 'Jeres sikkerhedscertifikater er blevet indsendt og er nu under gennemgang. Vi kontakter jer, hvis yderligere oplysninger er påkrævet.',
		'removeDocument': 'Fjern',
		'certificateNumber': 'Certifikatnummer',
		'certificateType': 'Certifikattype',
		'certificateIssuer': 'Udsteder',
		'validUntil': 'Gyldig indtil',
		'processingFeedback': 'Behandlingsfeedback',
		'noCertificatesFoundTitle': 'Ingen certifikater fundet',
		'noCertificatesFoundMessage': 'Vi kunne ikke automatisk finde nogen sikkerhedscertifikater. Upload venligst jeres certifikater manuelt ved hjælp af upload-sektionen nedenfor.',
		'gapAnalysisCheckbox': 'Jeg har ingen certifikater, men ønsker at udføre en gap-analyse',
		'gapAnalysisUploadTitle': 'Upload gap-analyse',
		'gapAnalysisUploadSubtitle': 'Upload venligst jeres udfyldte gap-analyse dokument.',
		'gapAnalysisTemplateLink': 'Download gap-analyse skabelon',
		'uploadDocument': 'Upload dokument',
		'dropFileHere': 'Slip filen her...',
		'dragDropFile': 'Træk og slip en fil her, eller klik for at vælge en fil',
		'uploading': 'Uploader',
		'uploadFailed': 'Upload mislykkedes',
		'dismiss': 'Afvis',
		'requiredDocumentsUploaded': 'Påkrævede dokumenter',
		'optionalDocumentsUploaded': 'Valgfrie dokumenter',
		'otherDocumentsUploaded': 'Andre dokumenter',
		'recognizedAs': 'Genkendt som',
		'aiProcessingSubtext': 'AI behandler dit dokument',
		'uploadTitle': 'Validering og mangelanalyse',
		'analysisCompleteLabel': 'Analyse fuldført',
		'summaryText': 'Du har brug for {total}. {missing} mangler i øjeblikket i din profil.',
		'verifiedLabel': 'VERIFICERET',
		'actionRequiredLabel': 'HANDLING PÅKRÆVET',
		'uploadDocumentsSubtitle': 'Træk og slip filer her, eller klik for at vælge. Systemet registrerer automatisk dokumenttypen.',
		'noDocumentsNeededTitle': 'Ingen dokumenter påkrævet',
		'noDocumentsNeededMessage': 'Baseret på dine svar kræves ingen yderligere sikkerhedscertifikater for denne arbejdstype.',
		'missingCertificationsAcknowledgment': 'Jeg anerkender de manglende certifikater og bekræfter, at jeg har gyldige midlertidige papirkopier til fremvisning på stedet.',
		'summaryTextAllComplete': 'Alle påkrævede certifikater er tilgængelige.',
		'oneOfFollowingLabel': 'Upload mindst ét af følgende:',
		'certificateSingular': 'certifikat',
		'certificatePlural': 'certifikater',
		'missingCountSingular': 'mangler',
		'missingCountPlural': 'mangler',
		'expiresLabel': 'UDLØBER',
		'orSeparator': ' eller '
	},
	'ES': {
		'yesLabel': 'Sí',
		'noLabel': 'No',
		'intro': 'Necesitamos recopilar sus certificados de seguridad para garantizar el cumplimiento de los requisitos del sitio. Este proceso nos ayudará a verificar sus calificaciones y garantizar que puede realizar el trabajo de forma segura en el sitio.',
		'userDetailsTitle': 'Por favor proporcione sus datos',
		'lblFirstName': 'Nombre',
		'lblLastName': 'Apellido',
		'lblDOB': 'Fecha de nacimiento',
		'lblVAT': 'Número de IVA',
		'processingText': 'Buscando sus certificados de seguridad...',
		'confirmationTitle': 'Revise sus certificados de seguridad',
		'confirmationRequiredSubtitle': 'Los siguientes tipos son obligatorios: ',
		'confirmationRequiredSatisfied': 'Todos los documentos requeridos están proporcionados',
		'confirmationOptionalSubtitle': 'Los siguientes tipos son opcionales: ',
		'foundCertificatesTitle': 'Certificados encontrados',
		'foundCertificatesSubtitle': 'Encontramos los siguientes certificados. Por favor deseleccione los que no sean relevantes o pertenezcan a otra persona:',
		'uploadDocumentsTitle': 'Subir documentos',
		'uploadedDocumentsSubtitle': 'Revise sus documentos subidos y elimine los que no sean relevantes:',
		'noDocumentsCheckbox': 'Confirmo que deseo continuar sin enviar certificados de seguridad y entiendo que esto puede afectar mi capacidad para realizar trabajo en el sitio.',
		'thankYouTitle': 'Gracias por su envío',
		'thankYouText': 'Sus certificados de seguridad han sido enviados y ahora están sujetos a revisión. Nos pondremos en contacto con usted si se requiere información adicional.',
		'removeDocument': 'Eliminar',
		'certificateNumber': 'Número de certificado',
		'certificateType': 'Tipo de certificado',
		'certificateIssuer': 'Emisor',
		'validUntil': 'Válido hasta',
		'processingFeedback': 'Comentarios de procesamiento',
		'noCertificatesFoundTitle': 'No se encontraron certificados',
		'noCertificatesFoundMessage': 'No pudimos encontrar automáticamente ningún certificado de seguridad. Por favor suba sus certificados manualmente usando la sección de carga a continuación.',
		'gapAnalysisCheckbox': 'No tengo certificados, pero quiero realizar un análisis de brechas',
		'gapAnalysisUploadTitle': 'Subir análisis de brechas',
		'gapAnalysisUploadSubtitle': 'Por favor suba su documento de análisis de brechas completado.',
		'gapAnalysisTemplateLink': 'Descargar plantilla de análisis de brechas',
		'uploadDocument': 'Subir documento',
		'dropFileHere': 'Suelte el archivo aquí...',
		'dragDropFile': 'Arrastre y suelte un archivo aquí o haga clic para seleccionar un archivo',
		'uploading': 'Subiendo',
		'uploadFailed': 'La carga falló',
		'dismiss': 'Descartar',
		'requiredDocumentsUploaded': 'Documentos requeridos',
		'optionalDocumentsUploaded': 'Documentos opcionales',
		'otherDocumentsUploaded': 'Otros documentos',
		'recognizedAs': 'Reconocido como',
		'aiProcessingSubtext': 'La IA está procesando su documento',
		'uploadTitle': 'Validación y análisis de brechas',
		'analysisCompleteLabel': 'Análisis completado',
		'summaryText': 'Necesita {total}. {missing} falta(n) actualmente en su perfil.',
		'verifiedLabel': 'VERIFICADO',
		'actionRequiredLabel': 'ACCIÓN REQUERIDA',
		'uploadDocumentsSubtitle': 'Arrastre y suelte archivos aquí o haga clic para seleccionar. El sistema detectará automáticamente el tipo de documento.',
		'noDocumentsNeededTitle': 'No se requieren documentos',
		'noDocumentsNeededMessage': 'Según sus respuestas, no se requieren certificados de seguridad adicionales para este tipo de trabajo.',
		'missingCertificationsAcknowledgment': 'Reconozco las certificaciones faltantes y confirmo que tengo copias en papel temporales válidas para presentar en el sitio.',
		'summaryTextAllComplete': 'Todos los certificados requeridos están disponibles.',
		'oneOfFollowingLabel': 'Suba al menos uno de los siguientes:',
		'certificateSingular': 'certificado',
		'certificatePlural': 'certificados',
		'missingCountSingular': 'falta',
		'missingCountPlural': 'faltan',
		'expiresLabel': 'VENCE',
		'orSeparator': ' o '
	},
	'FI': {
		'yesLabel': 'Kyllä',
		'noLabel': 'Ei',
		'intro': 'Meidän on kerättävä turvallisuustodistukset varmistaaksemme, että noudatamme työmaan vaatimuksia. Tämä prosessi auttaa meitä vahvistamaan pätevyytenne ja varmistamaan, että voitte turvallisesti suorittaa työtä työmaalla.',
		'userDetailsTitle': 'Anna tietosi',
		'lblFirstName': 'Etunimi',
		'lblLastName': 'Sukunimi',
		'lblDOB': 'Syntymäaika',
		'lblVAT': 'ALV-numero',
		'processingText': 'Etsitään turvallisuustodistuksia...',
		'confirmationTitle': 'Tarkista turvallisuustodistukset',
		'confirmationRequiredSubtitle': 'Seuraavat tyypit ovat pakollisia: ',
		'confirmationRequiredSatisfied': 'Kaikki vaaditut asiakirjat on toimitettu',
		'confirmationOptionalSubtitle': 'Seuraavat tyypit ovat valinnaisia: ',
		'foundCertificatesTitle': 'Löydetyt todistukset',
		'foundCertificatesSubtitle': 'Löysimme seuraavat todistukset. Poista valinta niistä, jotka eivät ole relevantteja tai kuuluvat toiselle henkilölle:',
		'uploadDocumentsTitle': 'Lataa asiakirjat',
		'uploadedDocumentsSubtitle': 'Tarkista lataamasi asiakirjat ja poista ne, jotka eivät ole relevantteja:',
		'noDocumentsCheckbox': 'Vahvistan, että haluan jatkaa ilman turvallisuustodistusten lähettämistä ja ymmärrän, että tämä voi vaikuttaa kykyyni suorittaa työtä työmaalla.',
		'thankYouTitle': 'Kiitos lähetyksestä',
		'thankYouText': 'Turvallisuustodistukset on lähetetty ja ne ovat nyt tarkastettavana. Otamme yhteyttä, jos tarvitaan lisätietoja.',
		'removeDocument': 'Poista',
		'certificateNumber': 'Todistuksen numero',
		'certificateType': 'Todistuksen tyyppi',
		'certificateIssuer': 'Myöntäjä',
		'validUntil': 'Voimassa asti',
		'processingFeedback': 'Käsittelyn palaute',
		'noCertificatesFoundTitle': 'Todistuksia ei löytynyt',
		'noCertificatesFoundMessage': 'Emme löytäneet automaattisesti turvallisuustodistuksia. Lataa todistukset manuaalisesti käyttämällä alla olevaa latausosiota.',
		'gapAnalysisCheckbox': 'Minulla ei ole todistuksia, mutta haluan suorittaa aukkoanalyysin',
		'gapAnalysisUploadTitle': 'Lataa aukkoanalyysi',
		'gapAnalysisUploadSubtitle': 'Lataa täytetty aukkoanalyysi-asiakirja.',
		'gapAnalysisTemplateLink': 'Lataa aukkoanalyysi-malli',
		'uploadDocument': 'Lataa asiakirja',
		'dropFileHere': 'Pudota tiedosto tähän...',
		'dragDropFile': 'Vedä ja pudota tiedosto tähän tai napsauta valitaksesi tiedoston',
		'uploading': 'Lataa',
		'uploadFailed': 'Lataus epäonnistui',
		'dismiss': 'Hylkää',
		'requiredDocumentsUploaded': 'Vaaditut asiakirjat',
		'optionalDocumentsUploaded': 'Valinnaiset asiakirjat',
		'otherDocumentsUploaded': 'Muut asiakirjat',
		'recognizedAs': 'Tunnistettu muodossa',
		'aiProcessingSubtext': 'Tekoäly käsittelee asiakirjaasi',
		'uploadTitle': 'Validointi ja puuteanalyysi',
		'analysisCompleteLabel': 'Analyysi valmis',
		'summaryText': 'Tarvitset {total}. {missing} puuttuu tällä hetkellä profiilissasi.',
		'verifiedLabel': 'VAHVISTETTU',
		'actionRequiredLabel': 'TOIMENPIDE VAADITAAN',
		'uploadDocumentsSubtitle': 'Vedä ja pudota tiedostot tähän tai napsauta valitaksesi. Järjestelmä tunnistaa asiakirjatyypin automaattisesti.',
		'noDocumentsNeededTitle': 'Asiakirjoja ei vaadita',
		'noDocumentsNeededMessage': 'Vastaustesi perusteella tähän työtyyppiin ei vaadita lisäturvallisuustodistuksia.',
		'missingCertificationsAcknowledgment': 'Tunnustan puuttuvat sertifioinnit ja vahvistan, että minulla on voimassa olevat tilapäiset paperikopiot esitettäväksi paikan päällä.',
		'summaryTextAllComplete': 'Kaikki vaaditut todistukset ovat saatavilla.',
		'oneOfFollowingLabel': 'Lataa vähintään yksi seuraavista:',
		'certificateSingular': 'todistus',
		'certificatePlural': 'todistusta',
		'missingCountSingular': 'puuttuu',
		'missingCountPlural': 'puuttuu',
		'expiresLabel': 'VANHENEE',
		'orSeparator': ' tai '
	},
	'HR': {
		'yesLabel': 'Da',
		'noLabel': 'Ne',
		'intro': 'Moramo prikupiti vaše sigurnosne certifikate kako bismo osigurali usklađenost sa zahtjevima mjesta. Ovaj proces će nam pomoći provjeriti vaše kvalifikacije i osigurati da možete sigurno obavljati posao na mjestu.',
		'userDetailsTitle': 'Molimo navedite svoje podatke',
		'lblFirstName': 'Ime',
		'lblLastName': 'Prezime',
		'lblDOB': 'Datum rođenja',
		'lblVAT': 'OIB',
		'processingText': 'Traženje vaših sigurnosnih certifikata...',
		'confirmationTitle': 'Pregledajte svoje sigurnosne certifikate',
		'confirmationRequiredSubtitle': 'Sljedeći tipovi su obavezni: ',
		'confirmationRequiredSatisfied': 'Svi potrebni dokumenti su dostavljeni',
		'confirmationOptionalSubtitle': 'Sljedeći tipovi su opcionalni: ',
		'foundCertificatesTitle': 'Pronađeni certifikati',
		'foundCertificatesSubtitle': 'Pronašli smo sljedeće certifikate. Molimo poništite odabir onih koji nisu relevantni ili pripadaju drugoj osobi:',
		'uploadDocumentsTitle': 'Učitaj dokumente',
		'uploadedDocumentsSubtitle': 'Pregledajte svoje učitane dokumente i uklonite one koji nisu relevantni:',
		'noDocumentsCheckbox': 'Potvrđujem da želim nastaviti bez slanja sigurnosnih certifikata i razumijem da to može utjecati na moju sposobnost obavljanja posla na mjestu.',
		'thankYouTitle': 'Hvala vam na slanju',
		'thankYouText': 'Vaši sigurnosni certifikati su poslani i sada su predmet pregleda. Kontaktirat ćemo vas ako su potrebne dodatne informacije.',
		'removeDocument': 'Ukloni',
		'certificateNumber': 'Broj certifikata',
		'certificateType': 'Tip certifikata',
		'certificateIssuer': 'Izdavatelj',
		'validUntil': 'Vrijedi do',
		'processingFeedback': 'Povratne informacije o obradi',
		'noCertificatesFoundTitle': 'Nisu pronađeni certifikati',
		'noCertificatesFoundMessage': 'Nismo mogli automatski pronaći sigurnosne certifikate. Molimo učitajte svoje certifikate ručno koristeći odjeljak za učitavanje u nastavku.',
		'gapAnalysisCheckbox': 'Nemam certifikate, ali želim izvršiti analizu praznina',
		'gapAnalysisUploadTitle': 'Učitaj analizu praznina',
		'gapAnalysisUploadSubtitle': 'Molimo učitajte svoj ispunjeni dokument analize praznina.',
		'gapAnalysisTemplateLink': 'Preuzmi predložak analize praznina',
		'uploadDocument': 'Učitaj dokument',
		'dropFileHere': 'Spustite datoteku ovdje...',
		'dragDropFile': 'Povucite i spustite datoteku ovdje ili kliknite za odabir datoteke',
		'uploading': 'Učitavanje',
		'uploadFailed': 'Učitavanje nije uspjelo',
		'dismiss': 'Odbaci',
		'requiredDocumentsUploaded': 'Potrebni dokumenti',
		'optionalDocumentsUploaded': 'Opcionalni dokumenti',
		'otherDocumentsUploaded': 'Ostali dokumenti',
		'recognizedAs': 'Prepoznato kao',
		'aiProcessingSubtext': 'AI obrađuje vaš dokument',
		'uploadTitle': 'Validacija i analiza praznina',
		'analysisCompleteLabel': 'Analiza završena',
		'summaryText': 'Trebate {total}. {missing} trenutno nedostaje u vašem profilu.',
		'verifiedLabel': 'POTVRĐENO',
		'actionRequiredLabel': 'POTREBNA RADNJA',
		'uploadDocumentsSubtitle': 'Povucite i ispustite datoteke ovdje ili kliknite za odabir. Sustav će automatski prepoznati vrstu dokumenta.',
		'noDocumentsNeededTitle': 'Nisu potrebni dokumenti',
		'noDocumentsNeededMessage': 'Na temelju vaših odgovora, za ovu vrstu posla nisu potrebni dodatni sigurnosni certifikati.',
		'missingCertificationsAcknowledgment': 'Potvrđujem nedostajuće certifikate i potvrđujem da imam valjane privremene papirnate kopije za predočenje na lokaciji.',
		'summaryTextAllComplete': 'Svi potrebni certifikati su dostupni.',
		'oneOfFollowingLabel': 'Učitajte barem jedan od sljedećih:',
		'certificateSingular': 'certifikat',
		'certificatePlural': 'certifikata',
		'missingCountSingular': 'nedostaje',
		'missingCountPlural': 'nedostaju',
		'expiresLabel': 'ISTIČE',
		'orSeparator': ' ili '
	},
	'HU': {
		'yesLabel': 'Igen',
		'noLabel': 'Nem',
		'intro': 'Össze kell gyűjtenünk az Ön biztonsági igazolványait, hogy biztosítsuk a helyszíni követelményeknek való megfelelést. Ez a folyamat segít nekünk ellenőrizni az Ön képzettségét és biztosítani, hogy biztonságosan végezzen munkát a helyszínen.',
		'userDetailsTitle': 'Kérjük, adja meg adatait',
		'lblFirstName': 'Keresztnév',
		'lblLastName': 'Vezetéknév',
		'lblDOB': 'Születési dátum',
		'lblVAT': 'ÁFA-szám',
		'processingText': 'Biztonsági igazolványok keresése...',
		'confirmationTitle': 'Tekintse át biztonsági igazolványait',
		'confirmationRequiredSubtitle': 'A következő típusok kötelezőek: ',
		'confirmationRequiredSatisfied': 'Minden szükséges dokumentum meg van adva',
		'confirmationOptionalSubtitle': 'A következő típusok opcionálisak: ',
		'foundCertificatesTitle': 'Talált igazolványok',
		'foundCertificatesSubtitle': 'A következő igazolványokat találtuk. Kérjük, törölje a kijelölést azokról, amelyek nem relevánsak vagy más személyhez tartoznak:',
		'uploadDocumentsTitle': 'Dokumentumok feltöltése',
		'uploadedDocumentsSubtitle': 'Tekintse át feltöltött dokumentumait és távolítsa el azokat, amelyek nem relevánsak:',
		'noDocumentsCheckbox': 'Megerősítem, hogy biztonsági igazolványok benyújtása nélkül szeretnék folytatni, és értem, hogy ez befolyásolhatja a helyszínen végzett munkavégzési képességemet.',
		'thankYouTitle': 'Köszönjük a benyújtást',
		'thankYouText': 'Biztonsági igazolványait benyújtottuk, és most áttekintés alatt állnak. Felvesszük Önnel a kapcsolatot, ha további információkra van szükség.',
		'removeDocument': 'Eltávolítás',
		'certificateNumber': 'Igazolvány száma',
		'certificateType': 'Igazolvány típusa',
		'certificateIssuer': 'Kibocsátó',
		'validUntil': 'Érvényes eddig',
		'processingFeedback': 'Feldolgozási visszajelzés',
		'noCertificatesFoundTitle': 'Nem találhatók igazolványok',
		'noCertificatesFoundMessage': 'Nem tudtunk automatikusan biztonsági igazolványokat találni. Kérjük, töltse fel igazolványait manuálisan az alábbi feltöltési szakasz használatával.',
		'gapAnalysisCheckbox': 'Nincsenek igazolványaim, de szeretnék hiányosságelemzést végezni',
		'gapAnalysisUploadTitle': 'Hiányosságelemzés feltöltése',
		'gapAnalysisUploadSubtitle': 'Kérjük, töltse fel kitöltött hiányosságelemzési dokumentumát.',
		'gapAnalysisTemplateLink': 'Hiányosságelemzés sablon letöltése',
		'uploadDocument': 'Dokumentum feltöltése',
		'dropFileHere': 'Húzza ide a fájlt...',
		'dragDropFile': 'Húzza ide és ejtse le a fájlt, vagy kattintson a fájl kiválasztásához',
		'uploading': 'Feltöltés',
		'uploadFailed': 'A feltöltés sikertelen',
		'dismiss': 'Elutasítás',
		'requiredDocumentsUploaded': 'Kötelező dokumentumok',
		'optionalDocumentsUploaded': 'Opcionális dokumentumok',
		'otherDocumentsUploaded': 'Egyéb dokumentumok',
		'recognizedAs': 'Felismerve mint',
		'aiProcessingSubtext': 'Az AI feldolgozza a dokumentumot',
		'uploadTitle': 'Ellenőrzés és hiányelemzés',
		'analysisCompleteLabel': 'Elemzés kész',
		'summaryText': '{total} szükséges. {missing} jelenleg hiányzik a profiljából.',
		'verifiedLabel': 'ELLENŐRZÖTT',
		'actionRequiredLabel': 'BEAVATKOZÁS SZÜKSÉGES',
		'uploadDocumentsSubtitle': 'Húzza ide a fájlokat, vagy kattintson a kiválasztáshoz. A rendszer automatikusan felismeri a dokumentum típusát.',
		'noDocumentsNeededTitle': 'Nincs szükség dokumentumokra',
		'noDocumentsNeededMessage': 'Válaszai alapján ehhez a munkatípushoz nem szükségesek további biztonsági igazolványok.',
		'missingCertificationsAcknowledgment': 'Tudomásul veszem a hiányzó tanúsítványokat és megerősítem, hogy rendelkezem érvényes ideiglenes papír másolatokkal a helyszíni bemutatáshoz.',
		'summaryTextAllComplete': 'Minden szükséges igazolvány elérhető.',
		'oneOfFollowingLabel': 'Töltsön fel legalább egyet a következők közül:',
		'certificateSingular': 'igazolvány',
		'certificatePlural': 'igazolvány',
		'missingCountSingular': 'hiányzik',
		'missingCountPlural': 'hiányzik',
		'expiresLabel': 'LEJÁR',
		'orSeparator': ' vagy '
	},
	'IT': {
		'yesLabel': 'Sì',
		'noLabel': 'No',
		'intro': 'Dobbiamo raccogliere i vostri certificati di sicurezza per garantire la conformità ai requisiti del sito. Questo processo ci aiuterà a verificare le vostre qualifiche e garantire che possiate svolgere il lavoro in sicurezza sul sito.',
		'userDetailsTitle': 'Si prega di fornire i vostri dati',
		'lblFirstName': 'Nome',
		'lblLastName': 'Cognome',
		'lblDOB': 'Data di nascita',
		'lblVAT': 'Partita IVA',
		'processingText': 'Ricerca dei vostri certificati di sicurezza...',
		'confirmationTitle': 'Rivedere i vostri certificati di sicurezza',
		'confirmationRequiredSubtitle': 'I seguenti tipi sono obbligatori: ',
		'confirmationRequiredSatisfied': 'Tutti i documenti richiesti sono forniti',
		'confirmationOptionalSubtitle': 'I seguenti tipi sono opzionali: ',
		'foundCertificatesTitle': 'Certificati trovati',
		'foundCertificatesSubtitle': 'Abbiamo trovato i seguenti certificati. Si prega di deselezionare quelli che non sono rilevanti o appartengono a un\'altra persona:',
		'uploadDocumentsTitle': 'Caricare documenti',
		'uploadedDocumentsSubtitle': 'Rivedere i documenti caricati e rimuovere quelli che non sono rilevanti:',
		'noDocumentsCheckbox': 'Confermo che desidero continuare senza inviare certificati di sicurezza e comprendo che ciò potrebbe influire sulla mia capacità di svolgere il lavoro sul sito.',
		'thankYouTitle': 'Grazie per la vostra presentazione',
		'thankYouText': 'I vostri certificati di sicurezza sono stati inviati e sono ora soggetti a revisione. Vi contatteremo se sono necessarie informazioni aggiuntive.',
		'removeDocument': 'Rimuovere',
		'certificateNumber': 'Numero certificato',
		'certificateType': 'Tipo di certificato',
		'certificateIssuer': 'Emittente',
		'validUntil': 'Valido fino al',
		'processingFeedback': 'Feedback di elaborazione',
		'noCertificatesFoundTitle': 'Nessun certificato trovato',
		'noCertificatesFoundMessage': 'Non siamo riusciti a trovare automaticamente certificati di sicurezza. Si prega di caricare i certificati manualmente utilizzando la sezione di caricamento qui sotto.',
		'gapAnalysisCheckbox': 'Non ho certificati, ma voglio eseguire un\'analisi delle lacune',
		'gapAnalysisUploadTitle': 'Caricare analisi delle lacune',
		'gapAnalysisUploadSubtitle': 'Si prega di caricare il documento di analisi delle lacune completato.',
		'gapAnalysisTemplateLink': 'Scaricare modello di analisi delle lacune',
		'uploadDocument': 'Caricare documento',
		'dropFileHere': 'Trascina il file qui...',
		'dragDropFile': 'Trascina e rilascia un file qui o fai clic per selezionare un file',
		'uploading': 'Caricamento',
		'uploadFailed': 'Caricamento fallito',
		'dismiss': 'Chiudi',
		'requiredDocumentsUploaded': 'Documenti richiesti',
		'optionalDocumentsUploaded': 'Documenti opzionali',
		'otherDocumentsUploaded': 'Altri documenti',
		'recognizedAs': 'Riconosciuto come',
		'aiProcessingSubtext': 'L\'IA sta elaborando il tuo documento',
		'uploadTitle': 'Validazione e analisi delle lacune',
		'analysisCompleteLabel': 'Analisi completata',
		'summaryText': 'Hai bisogno di {total}. {missing} manca/mancano attualmente dal tuo profilo.',
		'verifiedLabel': 'VERIFICATO',
		'actionRequiredLabel': 'AZIONE RICHIESTA',
		'uploadDocumentsSubtitle': 'Trascina e rilascia i file qui o fai clic per selezionare. Il sistema rileverà automaticamente il tipo di documento.',
		'noDocumentsNeededTitle': 'Nessun documento richiesto',
		'noDocumentsNeededMessage': 'In base alle vostre risposte, non sono richiesti certificati di sicurezza aggiuntivi per questo tipo di lavoro.',
		'missingCertificationsAcknowledgment': 'Riconosco le certificazioni mancanti e confermo di avere copie cartacee temporanee valide da presentare in loco.',
		'summaryTextAllComplete': 'Tutti i certificati richiesti sono disponibili.',
		'oneOfFollowingLabel': 'Carica almeno uno dei seguenti:',
		'certificateSingular': 'certificato',
		'certificatePlural': 'certificati',
		'missingCountSingular': 'manca',
		'missingCountPlural': 'mancano',
		'expiresLabel': 'SCADE IL',
		'orSeparator': ' o '
	},
	'NO': {
		'yesLabel': 'Ja',
		'noLabel': 'Nei',
		'intro': 'Vi må samle inn sikkerhetssertifikatene deres for å sikre overholdelse av stedets krav. Denne prosessen vil hjelpe oss med å verifisere kvalifikasjonene deres og sikre at dere trygt kan utføre arbeid på stedet.',
		'userDetailsTitle': 'Vennligst oppgi opplysningene deres',
		'lblFirstName': 'Fornavn',
		'lblLastName': 'Etternavn',
		'lblDOB': 'Fødselsdato',
		'lblVAT': 'MVA-nummer',
		'processingText': 'Søker etter sikkerhetssertifikatene deres...',
		'confirmationTitle': 'Gjennomgå sikkerhetssertifikatene deres',
		'confirmationRequiredSubtitle': 'Følgende typer er påkrevd: ',
		'confirmationRequiredSatisfied': 'Alle påkrevde dokumenter er levert',
		'confirmationOptionalSubtitle': 'Følgende typer er valgfrie: ',
		'foundCertificatesTitle': 'Funnet sertifikater',
		'foundCertificatesSubtitle': 'Vi har funnet følgende sertifikater. Vennligst fjern merkingen av de som ikke er relevante eller tilhører en annen person:',
		'uploadDocumentsTitle': 'Last opp dokumenter',
		'uploadedDocumentsSubtitle': 'Gjennomgå de opplastede dokumentene og fjern de som ikke er relevante:',
		'noDocumentsCheckbox': 'Jeg bekrefter at jeg ønsker å fortsette uten å sende inn sikkerhetssertifikater og forstår at dette kan påvirke min evne til å utføre arbeid på stedet.',
		'thankYouTitle': 'Takk for innsendingen',
		'thankYouText': 'Sikkerhetssertifikatene deres er sendt inn og er nå under gjennomgang. Vi kontakter dere hvis tilleggsopplysninger er nødvendig.',
		'removeDocument': 'Fjern',
		'certificateNumber': 'Sertifikatnummer',
		'certificateType': 'Sertifikattype',
		'certificateIssuer': 'Utsteder',
		'validUntil': 'Gyldig til',
		'processingFeedback': 'Behandlingsfeedback',
		'noCertificatesFoundTitle': 'Ingen sertifikater funnet',
		'noCertificatesFoundMessage': 'Vi kunne ikke automatisk finne noen sikkerhetssertifikater. Vennligst last opp sertifikatene deres manuelt ved hjelp av opplastingsseksjonen nedenfor.',
		'gapAnalysisCheckbox': 'Jeg har ingen sertifikater, men ønsker å utføre en gap-analyse',
		'gapAnalysisUploadTitle': 'Last opp gap-analyse',
		'gapAnalysisUploadSubtitle': 'Vennligst last opp det fullførte gap-analyse dokumentet.',
		'gapAnalysisTemplateLink': 'Last ned gap-analyse mal',
		'uploadDocument': 'Last opp dokument',
		'dropFileHere': 'Slipp filen her...',
		'dragDropFile': 'Dra og slipp en fil her, eller klikk for å velge en fil',
		'uploading': 'Laster opp',
		'uploadFailed': 'Opplasting mislyktes',
		'dismiss': 'Avvis',
		'requiredDocumentsUploaded': 'Påkrevde dokumenter',
		'optionalDocumentsUploaded': 'Valgfrie dokumenter',
		'otherDocumentsUploaded': 'Andre dokumenter',
		'recognizedAs': 'Gjenkjent som',
		'aiProcessingSubtext': 'AI behandler dokumentet ditt',
		'uploadTitle': 'Validering og mangelanalyse',
		'analysisCompleteLabel': 'Analyse fullført',
		'summaryText': 'Du trenger {total}. {missing} mangler for øyeblikket i profilen din.',
		'verifiedLabel': 'VERIFISERT',
		'actionRequiredLabel': 'HANDLING KREVES',
		'uploadDocumentsSubtitle': 'Dra og slipp filer her, eller klikk for å velge. Systemet vil automatisk gjenkjenne dokumenttypen.',
		'noDocumentsNeededTitle': 'Ingen dokumenter kreves',
		'noDocumentsNeededMessage': 'Basert på dine svar kreves det ingen ekstra sikkerhetssertifikater for denne arbeidstypen.',
		'missingCertificationsAcknowledgment': 'Jeg bekrefter de manglende sertifiseringene og bekrefter at jeg har gyldige midlertidige papirkopier å vise frem på stedet.',
		'summaryTextAllComplete': 'Alle påkrevde sertifikater er tilgjengelige.',
		'oneOfFollowingLabel': 'Last opp minst ett av følgende:',
		'certificateSingular': 'sertifikat',
		'certificatePlural': 'sertifikater',
		'missingCountSingular': 'mangler',
		'missingCountPlural': 'mangler',
		'expiresLabel': 'UTLØPER',
		'orSeparator': ' eller '
	},
	'PT': {
		'yesLabel': 'Sim',
		'noLabel': 'Não',
		'intro': 'Precisamos coletar seus certificados de segurança para garantir o cumprimento dos requisitos do local. Este processo nos ajudará a verificar suas qualificações e garantir que você possa realizar o trabalho com segurança no local.',
		'userDetailsTitle': 'Por favor, forneça seus dados',
		'lblFirstName': 'Primeiro nome',
		'lblLastName': 'Sobrenome',
		'lblDOB': 'Data de nascimento',
		'lblVAT': 'Número de IVA',
		'processingText': 'Procurando seus certificados de segurança...',
		'confirmationTitle': 'Revise seus certificados de segurança',
		'confirmationRequiredSubtitle': 'Os seguintes tipos são obrigatórios: ',
		'confirmationRequiredSatisfied': 'Todos os documentos necessários são fornecidos',
		'confirmationOptionalSubtitle': 'Os seguintes tipos são opcionais: ',
		'foundCertificatesTitle': 'Certificados encontrados',
		'foundCertificatesSubtitle': 'Encontramos os seguintes certificados. Por favor, desmarque aqueles que não são relevantes ou pertencem a outra pessoa:',
		'uploadDocumentsTitle': 'Carregar documentos',
		'uploadedDocumentsSubtitle': 'Revise seus documentos carregados e remova aqueles que não são relevantes:',
		'noDocumentsCheckbox': 'Confirmo que desejo continuar sem enviar certificados de segurança e entendo que isso pode afetar minha capacidade de realizar trabalho no local.',
		'thankYouTitle': 'Obrigado pelo seu envio',
		'thankYouText': 'Seus certificados de segurança foram enviados e estão agora sujeitos a revisão. Entraremos em contato se informações adicionais forem necessárias.',
		'removeDocument': 'Remover',
		'certificateNumber': 'Número do certificado',
		'certificateType': 'Tipo de certificado',
		'certificateIssuer': 'Emissor',
		'validUntil': 'Válido até',
		'processingFeedback': 'Feedback de processamento',
		'noCertificatesFoundTitle': 'Nenhum certificado encontrado',
		'noCertificatesFoundMessage': 'Não conseguimos encontrar automaticamente certificados de segurança. Por favor, carregue seus certificados manualmente usando a seção de carregamento abaixo.',
		'gapAnalysisCheckbox': 'Não tenho certificados, mas quero realizar uma análise de lacunas',
		'gapAnalysisUploadTitle': 'Carregar análise de lacunas',
		'gapAnalysisUploadSubtitle': 'Por favor, carregue seu documento de análise de lacunas preenchido.',
		'gapAnalysisTemplateLink': 'Baixar modelo de análise de lacunas',
		'uploadDocument': 'Carregar documento',
		'dropFileHere': 'Solte o arquivo aqui...',
		'dragDropFile': 'Arraste e solte um arquivo aqui ou clique para selecionar um arquivo',
		'uploading': 'Carregando',
		'uploadFailed': 'Falha no carregamento',
		'dismiss': 'Descartar',
		'requiredDocumentsUploaded': 'Documentos necessários',
		'optionalDocumentsUploaded': 'Documentos opcionais',
		'otherDocumentsUploaded': 'Outros documentos',
		'recognizedAs': 'Reconhecido como',
		'aiProcessingSubtext': 'A IA está a processar o seu documento',
		'uploadTitle': 'Validação e análise de lacunas',
		'analysisCompleteLabel': 'Análise concluída',
		'summaryText': 'Você precisa de {total}. {missing} falta(m) atualmente no seu perfil.',
		'verifiedLabel': 'VERIFICADO',
		'actionRequiredLabel': 'AÇÃO NECESSÁRIA',
		'uploadDocumentsSubtitle': 'Arraste e solte arquivos aqui ou clique para selecionar. O sistema detectará automaticamente o tipo de documento.',
		'noDocumentsNeededTitle': 'Nenhum documento necessário',
		'noDocumentsNeededMessage': 'Com base nas suas respostas, não são necessários certificados de segurança adicionais para este tipo de trabalho.',
		'missingCertificationsAcknowledgment': 'Reconheço as certificações em falta e confirmo que tenho cópias em papel temporárias válidas para apresentar no local.',
		'summaryTextAllComplete': 'Todos os certificados necessários estão disponíveis.',
		'oneOfFollowingLabel': 'Carregue pelo menos um dos seguintes:',
		'certificateSingular': 'certificado',
		'certificatePlural': 'certificados',
		'missingCountSingular': 'falta',
		'missingCountPlural': 'faltam',
		'expiresLabel': 'EXPIRA',
		'orSeparator': ' ou '
	},
	'RO': {
		'yesLabel': 'Da',
		'noLabel': 'Nu',
		'intro': 'Trebuie să colectăm certificatele dvs. de siguranță pentru a asigura conformitatea cu cerințele site-ului. Acest proces ne va ajuta să verificăm calificările dvs. și să ne asigurăm că puteți efectua lucrări în siguranță pe șantier.',
		'userDetailsTitle': 'Vă rugăm să furnizați datele dvs.',
		'lblFirstName': 'Prenume',
		'lblLastName': 'Nume de familie',
		'lblDOB': 'Data nașterii',
		'lblVAT': 'Număr TVA',
		'processingText': 'Căutarea certificatelor dvs. de siguranță...',
		'confirmationTitle': 'Examinați certificatele dvs. de siguranță',
		'confirmationRequiredSubtitle': 'Următoarele tipuri sunt obligatorii: ',
		'confirmationRequiredSatisfied': 'Toate documentele necesare sunt furnizate',
		'confirmationOptionalSubtitle': 'Următoarele tipuri sunt opționale: ',
		'foundCertificatesTitle': 'Certificate găsite',
		'foundCertificatesSubtitle': 'Am găsit următoarele certificate. Vă rugăm să deselectați cele care nu sunt relevante sau aparțin altei persoane:',
		'uploadDocumentsTitle': 'Încărcați documente',
		'uploadedDocumentsSubtitle': 'Examinați documentele dvs. încărcate și eliminați cele care nu sunt relevante:',
		'noDocumentsCheckbox': 'Confirm că doresc să continui fără să trimit certificate de siguranță și înțeleg că acest lucru poate afecta capacitatea mea de a efectua lucrări pe șantier.',
		'thankYouTitle': 'Vă mulțumim pentru trimitere',
		'thankYouText': 'Certificatele dvs. de siguranță au fost trimise și sunt acum supuse revizuirii. Vă vom contacta dacă sunt necesare informații suplimentare.',
		'removeDocument': 'Eliminați',
		'certificateNumber': 'Număr certificat',
		'certificateType': 'Tip certificat',
		'certificateIssuer': 'Emitent',
		'validUntil': 'Valabil până la',
		'processingFeedback': 'Feedback procesare',
		'noCertificatesFoundTitle': 'Nu au fost găsite certificate',
		'noCertificatesFoundMessage': 'Nu am putut găsi automat certificate de siguranță. Vă rugăm să încărcați certificatele dvs. manual folosind secțiunea de încărcare de mai jos.',
		'gapAnalysisCheckbox': 'Nu am certificate, dar doresc să efectuez o analiză a lacunelor',
		'gapAnalysisUploadTitle': 'Încărcați analiza lacunelor',
		'gapAnalysisUploadSubtitle': 'Vă rugăm să încărcați documentul dvs. de analiză a lacunelor completat.',
		'gapAnalysisTemplateLink': 'Descărcați șablonul de analiză a lacunelor',
		'uploadDocument': 'Încărcați document',
		'dropFileHere': 'Aruncați fișierul aici...',
		'dragDropFile': 'Trageți și plasați un fișier aici sau faceți clic pentru a selecta un fișier',
		'uploading': 'Se încarcă',
		'uploadFailed': 'Încărcarea a eșuat',
		'dismiss': 'Respinge',
		'requiredDocumentsUploaded': 'Documente necesare',
		'optionalDocumentsUploaded': 'Documente opționale',
		'otherDocumentsUploaded': 'Alte documente',
		'recognizedAs': 'Recunoscut ca',
		'aiProcessingSubtext': 'AI procesează documentul dvs.',
		'uploadTitle': 'Validare și analiză a lacunelor',
		'analysisCompleteLabel': 'Analiză finalizată',
		'summaryText': 'Aveți nevoie de {total}. {missing} lipsește/lipsesc în prezent din profilul dvs.',
		'verifiedLabel': 'VERIFICAT',
		'actionRequiredLabel': 'ACȚIUNE NECESARĂ',
		'uploadDocumentsSubtitle': 'Trageți și plasați fișiere aici sau faceți clic pentru a selecta. Sistemul va detecta automat tipul documentului.',
		'noDocumentsNeededTitle': 'Nu sunt necesare documente',
		'noDocumentsNeededMessage': 'Pe baza răspunsurilor dvs., nu sunt necesare certificate de siguranță suplimentare pentru acest tip de lucrare.',
		'missingCertificationsAcknowledgment': 'Recunosc certificările lipsă și confirm că am copii de hârtie temporare valide pentru prezentare pe șantier.',
		'summaryTextAllComplete': 'Toate certificatele necesare sunt disponibile.',
		'oneOfFollowingLabel': 'Încărcați cel puțin unul dintre următoarele:',
		'certificateSingular': 'certificat',
		'certificatePlural': 'certificate',
		'missingCountSingular': 'lipsește',
		'missingCountPlural': 'lipsesc',
		'expiresLabel': 'EXPIRĂ',
		'orSeparator': ' sau '
	},
	'RU': {
		'yesLabel': 'Да',
		'noLabel': 'Нет',
		'intro': 'Нам нужно собрать ваши сертификаты безопасности, чтобы обеспечить соответствие требованиям объекта. Этот процесс поможет нам проверить вашу квалификацию и убедиться, что вы можете безопасно выполнять работу на объекте.',
		'userDetailsTitle': 'Пожалуйста, предоставьте ваши данные',
		'lblFirstName': 'Имя',
		'lblLastName': 'Фамилия',
		'lblDOB': 'Дата рождения',
		'lblVAT': 'Номер НДС',
		'processingText': 'Поиск ваших сертификатов безопасности...',
		'confirmationTitle': 'Проверьте ваши сертификаты безопасности',
		'confirmationRequiredSubtitle': 'Следующие типы обязательны: ',
		'confirmationRequiredSatisfied': 'Все необходимые документы предоставлены',
		'confirmationOptionalSubtitle': 'Следующие типы являются необязательными: ',
		'foundCertificatesTitle': 'Найденные сертификаты',
		'foundCertificatesSubtitle': 'Мы нашли следующие сертификаты. Пожалуйста, снимите выделение с тех, которые не относятся к делу или принадлежат другому лицу:',
		'uploadDocumentsTitle': 'Загрузить документы',
		'uploadedDocumentsSubtitle': 'Проверьте ваши загруженные документы и удалите те, которые не относятся к делу:',
		'noDocumentsCheckbox': 'Я подтверждаю, что хочу продолжить без отправки сертификатов безопасности и понимаю, что это может повлиять на мою способность выполнять работу на объекте.',
		'thankYouTitle': 'Спасибо за вашу отправку',
		'thankYouText': 'Ваши сертификаты безопасности были отправлены и теперь проходят проверку. Мы свяжемся с вами, если потребуется дополнительная информация.',
		'removeDocument': 'Удалить',
		'certificateNumber': 'Номер сертификата',
		'certificateType': 'Тип сертификата',
		'certificateIssuer': 'Издатель',
		'validUntil': 'Действителен до',
		'processingFeedback': 'Обратная связь по обработке',
		'noCertificatesFoundTitle': 'Сертификаты не найдены',
		'noCertificatesFoundMessage': 'Мы не смогли автоматически найти сертификаты безопасности. Пожалуйста, загрузите ваши сертификаты вручную, используя раздел загрузки ниже.',
		'gapAnalysisCheckbox': 'У меня нет сертификатов, но я хочу провести анализ пробелов',
		'gapAnalysisUploadTitle': 'Загрузить анализ пробелов',
		'gapAnalysisUploadSubtitle': 'Пожалуйста, загрузите ваш заполненный документ анализа пробелов.',
		'gapAnalysisTemplateLink': 'Скачать шаблон анализа пробелов',
		'uploadDocument': 'Загрузить документ',
		'dropFileHere': 'Перетащите файл сюда...',
		'dragDropFile': 'Перетащите и отпустите файл сюда или нажмите, чтобы выбрать файл',
		'uploading': 'Загрузка',
		'uploadFailed': 'Загрузка не удалась',
		'dismiss': 'Отклонить',
		'requiredDocumentsUploaded': 'Обязательные документы',
		'optionalDocumentsUploaded': 'Необязательные документы',
		'otherDocumentsUploaded': 'Другие документы',
		'recognizedAs': 'Распознано как',
		'aiProcessingSubtext': 'ИИ обрабатывает ваш документ',
		'uploadTitle': 'Проверка и анализ пробелов',
		'analysisCompleteLabel': 'Анализ завершён',
		'summaryText': 'Вам необходимо {total}. {missing} в настоящее время отсутствует в вашем профиле.',
		'verifiedLabel': 'ПРОВЕРЕНО',
		'actionRequiredLabel': 'ТРЕБУЕТСЯ ДЕЙСТВИЕ',
		'uploadDocumentsSubtitle': 'Перетащите файлы сюда или нажмите для выбора. Система автоматически определит тип документа.',
		'noDocumentsNeededTitle': 'Документы не требуются',
		'noDocumentsNeededMessage': 'Исходя из ваших ответов, для данного вида работ не требуются дополнительные сертификаты безопасности.',
		'missingCertificationsAcknowledgment': 'Я подтверждаю отсутствующие сертификаты и подтверждаю, что у меня есть действующие временные бумажные копии для предъявления на объекте.',
		'summaryTextAllComplete': 'Все необходимые сертификаты доступны.',
		'oneOfFollowingLabel': 'Загрузите хотя бы один из следующих:',
		'certificateSingular': 'сертификат',
		'certificatePlural': 'сертификатов',
		'missingCountSingular': 'отсутствует',
		'missingCountPlural': 'отсутствуют',
		'expiresLabel': 'ИСТЕКАЕТ',
		'orSeparator': ' или '
	},
	'SK': {
		'yesLabel': 'Áno',
		'noLabel': 'Nie',
		'intro': 'Musíme zhromaždiť vaše bezpečnostné certifikáty, aby sme zabezpečili súlad s požiadavkami na mieste. Tento proces nám pomôže overiť vaše kvalifikácie a zabezpečiť, že môžete bezpečne vykonávať prácu na mieste.',
		'userDetailsTitle': 'Uveďte prosím svoje údaje',
		'lblFirstName': 'Meno',
		'lblLastName': 'Priezvisko',
		'lblDOB': 'Dátum narodenia',
		'lblVAT': 'IČ DPH',
		'processingText': 'Vyhľadávanie vašich bezpečnostných certifikátov...',
		'confirmationTitle': 'Skontrolujte svoje bezpečnostné certifikáty',
		'confirmationRequiredSubtitle': 'Nasledujúce typy sú povinné: ',
		'confirmationRequiredSatisfied': 'Všetky požadované dokumenty sú poskytnuté',
		'confirmationOptionalSubtitle': 'Nasledujúce typy sú voliteľné: ',
		'foundCertificatesTitle': 'Nájdené certifikáty',
		'foundCertificatesSubtitle': 'Našli sme nasledujúce certifikáty. Prosím zrušte výber tých, ktoré nie sú relevantné alebo patria inej osobe:',
		'uploadDocumentsTitle': 'Nahrať dokumenty',
		'uploadedDocumentsSubtitle': 'Skontrolujte svoje nahrané dokumenty a odstráňte tie, ktoré nie sú relevantné:',
		'noDocumentsCheckbox': 'Potvrdzujem, že chcem pokračovať bez predloženia bezpečnostných certifikátov a chápem, že to môže ovplyvniť moju schopnosť vykonávať prácu na mieste.',
		'thankYouTitle': 'Ďakujeme za vaše podanie',
		'thankYouText': 'Vaše bezpečnostné certifikáty boli predložené a sú teraz predmetom kontroly. Kontaktujeme vás, ak budú požadované ďalšie informácie.',
		'removeDocument': 'Odstrániť',
		'certificateNumber': 'Číslo certifikátu',
		'certificateType': 'Typ certifikátu',
		'certificateIssuer': 'Vydavateľ',
		'validUntil': 'Platný do',
		'processingFeedback': 'Spätná väzba spracovania',
		'noCertificatesFoundTitle': 'Neboli nájdené žiadne certifikáty',
		'noCertificatesFoundMessage': 'Nemohli sme automaticky nájsť žiadne bezpečnostné certifikáty. Nahrajte prosím svoje certifikáty ručne pomocou sekcie pre nahrávanie nižšie.',
		'gapAnalysisCheckbox': 'Nemám žiadne certifikáty, ale chcem vykonať analýzu medzier',
		'gapAnalysisUploadTitle': 'Nahrať analýzu medzier',
		'gapAnalysisUploadSubtitle': 'Nahrajte prosím svoj vyplnený dokument analýzy medzier.',
		'gapAnalysisTemplateLink': 'Stiahnuť šablónu analýzy medzier',
		'uploadDocument': 'Nahrať dokument',
		'dropFileHere': 'Presuňte súbor sem...',
		'dragDropFile': 'Presuňte a pustite súbor sem alebo kliknite pre výber súboru',
		'uploading': 'Nahrávanie',
		'uploadFailed': 'Nahrávanie zlyhalo',
		'dismiss': 'Zavrieť',
		'requiredDocumentsUploaded': 'Povinné dokumenty',
		'optionalDocumentsUploaded': 'Volitelné dokumenty',
		'otherDocumentsUploaded': 'Iné dokumenty',
		'recognizedAs': 'Rozpoznané ako',
		'aiProcessingSubtext': 'AI spracováva váš dokument',
		'uploadTitle': 'Validácia a analýza medzier',
		'analysisCompleteLabel': 'Analýza dokončená',
		'summaryText': 'Potrebujete {total}. {missing} v súčasnosti chýba vo vašom profile.',
		'verifiedLabel': 'OVERENÉ',
		'actionRequiredLabel': 'VYŽADOVANÁ AKCIA',
		'uploadDocumentsSubtitle': 'Presuňte súbory sem alebo kliknite pre výber. Systém automaticky rozpozná typ dokumentu.',
		'noDocumentsNeededTitle': 'Nie sú vyžadované žiadne dokumenty',
		'noDocumentsNeededMessage': 'Na základe vašich odpovedí nie sú pre tento typ práce vyžadované žiadne ďalšie bezpečnostné certifikáty.',
		'missingCertificationsAcknowledgment': 'Potvrdzujem chýbajúce certifikáty a potvrdzujem, že mám platné dočasné papierové kópie na predloženie na mieste.',
		'summaryTextAllComplete': 'Všetky požadované certifikáty sú dostupné.',
		'oneOfFollowingLabel': 'Nahrajte aspoň jeden z nasledujúcich:',
		'certificateSingular': 'certifikát',
		'certificatePlural': 'certifikátov',
		'missingCountSingular': 'chýba',
		'missingCountPlural': 'chýbajú',
		'expiresLabel': 'PLATNOSŤ DO',
		'orSeparator': ' alebo '
	},
	'SI': {
		'yesLabel': 'Da',
		'noLabel': 'Ne',
		'intro': 'Zbrati moramo vaše varnostne certifikate, da zagotovimo skladnost z zahtevami na lokaciji. Ta postopek nam bo pomagal preveriti vaše kvalifikacije in zagotoviti, da lahko varno opravljate delo na lokaciji.',
		'userDetailsTitle': 'Prosimo, navedite svoje podatke',
		'lblFirstName': 'Ime',
		'lblLastName': 'Priimek',
		'lblDOB': 'Datum rojstva',
		'lblVAT': 'ID za DDV',
		'processingText': 'Iskanje vaših varnostnih certifikatov...',
		'confirmationTitle': 'Preglejte svoje varnostne certifikate',
		'confirmationRequiredSubtitle': 'Naslednje vrste so obvezne: ',
		'confirmationRequiredSatisfied': 'Vsi potrebni dokumenti so zagotovljeni',
		'confirmationOptionalSubtitle': 'Naslednje vrste so neobvezne: ',
		'foundCertificatesTitle': 'Najdeni certifikati',
		'foundCertificatesSubtitle': 'Našli smo naslednje certifikate. Prosimo, prekličite izbor tistih, ki niso relevantni ali pripadajo drugi osebi:',
		'uploadDocumentsTitle': 'Naložite dokumente',
		'uploadedDocumentsSubtitle': 'Preglejte svoje naložene dokumente in odstranite tiste, ki niso relevantni:',
		'noDocumentsCheckbox': 'Potrjujem, da želim nadaljevati brez oddaje varnostnih certifikatov in razumem, da to lahko vpliva na mojo sposobnost opravljanja dela na lokaciji.',
		'thankYouTitle': 'Hvala za vašo oddajo',
		'thankYouText': 'Vaši varnostni certifikati so bili oddani in so zdaj predmet pregleda. Kontaktirali vas bomo, če so potrebne dodatne informacije.',
		'removeDocument': 'Odstrani',
		'certificateNumber': 'Številka certifikata',
		'certificateType': 'Vrsta certifikata',
		'certificateIssuer': 'Izdajatelj',
		'validUntil': 'Velja do',
		'processingFeedback': 'Povratne informacije o obdelavi',
		'noCertificatesFoundTitle': 'Ni najdenih certifikatov',
		'noCertificatesFoundMessage': 'Nismo mogli samodejno najti varnostnih certifikatov. Prosimo, naložite svoje certifikate ročno z uporabo razdelka za nalaganje spodaj.',
		'gapAnalysisCheckbox': 'Nimam certifikatov, vendar želim izvesti analizo vrzeli',
		'gapAnalysisUploadTitle': 'Naložite analizo vrzeli',
		'gapAnalysisUploadSubtitle': 'Prosimo, naložite svoj izpolnjen dokument analize vrzeli.',
		'gapAnalysisTemplateLink': 'Prenesite predlogo analize vrzeli',
		'uploadDocument': 'Naložite dokument',
		'dropFileHere': 'Spustite datoteko tukaj...',
		'dragDropFile': 'Povlecite in spustite datoteko tukaj ali kliknite za izbiro datoteke',
		'uploading': 'Nalaganje',
		'uploadFailed': 'Nalaganje ni uspelo',
		'dismiss': 'Zavrni',
		'requiredDocumentsUploaded': 'Zahtevani dokumenti',
		'optionalDocumentsUploaded': 'Neobvezni dokumenti',
		'otherDocumentsUploaded': 'Drugi dokumenti',
		'recognizedAs': 'Prepoznano kot',
		'aiProcessingSubtext': 'AI obdeluje vaš dokument',
		'uploadTitle': 'Validacija in analiza vrzeli',
		'analysisCompleteLabel': 'Analiza zaključena',
		'summaryText': 'Potrebujete {total}. {missing} trenutno manjka v vašem profilu.',
		'verifiedLabel': 'PREVERJENO',
		'actionRequiredLabel': 'POTREBNO UKREPANJE',
		'uploadDocumentsSubtitle': 'Povlecite in spustite datoteke sem ali kliknite za izbiro. Sistem bo samodejno zaznal vrsto dokumenta.',
		'noDocumentsNeededTitle': 'Dokumenti niso potrebni',
		'noDocumentsNeededMessage': 'Na podlagi vaših odgovorov za to vrsto dela niso potrebni dodatni varnostni certifikati.',
		'missingCertificationsAcknowledgment': 'Potrjujem manjkajoče certifikate in potrjujem, da imam veljavne začasne papirne kopije za predložitev na lokaciji.',
		'summaryTextAllComplete': 'Vsi zahtevani certifikati so na voljo.',
		'oneOfFollowingLabel': 'Naložite vsaj enega od naslednjih:',
		'certificateSingular': 'certifikat',
		'certificatePlural': 'certifikatov',
		'missingCountSingular': 'manjka',
		'missingCountPlural': 'manjkajo',
		'expiresLabel': 'POTEČE',
		'orSeparator': ' ali '
	},
	'SV': {
		'yesLabel': 'Ja',
		'noLabel': 'Nej',
		'intro': 'Vi behöver samla in era säkerhetscertifikat för att säkerställa överensstämmelse med platsens krav. Denna process hjälper oss att verifiera era kvalifikationer och säkerställa att ni säkert kan utföra arbete på platsen.',
		'userDetailsTitle': 'Vänligen ange era uppgifter',
		'lblFirstName': 'Förnamn',
		'lblLastName': 'Efternamn',
		'lblDOB': 'Födelsedatum',
		'lblVAT': 'Momsregistreringsnummer',
		'processingText': 'Söker efter era säkerhetscertifikat...',
		'confirmationTitle': 'Granska era säkerhetscertifikat',
		'confirmationRequiredSubtitle': 'Följande typer är obligatoriska: ',
		'confirmationRequiredSatisfied': 'Alla nödvändiga dokument är tillhandahållna',
		'confirmationOptionalSubtitle': 'Följande typer är valfria: ',
		'foundCertificatesTitle': 'Hittade certifikat',
		'foundCertificatesSubtitle': 'Vi har hittat följande certifikat. Vänligen avmarkera de som inte är relevanta eller tillhör en annan person:',
		'uploadDocumentsTitle': 'Ladda upp dokument',
		'uploadedDocumentsSubtitle': 'Granska dina uppladdade dokument och ta bort de som inte är relevanta:',
		'noDocumentsCheckbox': 'Jag bekräftar att jag vill fortsätta utan att skicka in säkerhetscertifikat och förstår att detta kan påverka min förmåga att utföra arbete på platsen.',
		'thankYouTitle': 'Tack för din inlämning',
		'thankYouText': 'Dina säkerhetscertifikat har skickats in och är nu under granskning. Vi kontaktar dig om ytterligare information behövs.',
		'removeDocument': 'Ta bort',
		'certificateNumber': 'Certifikatnummer',
		'certificateType': 'Certifikattyp',
		'certificateIssuer': 'Utfärdare',
		'validUntil': 'Giltigt till',
		'processingFeedback': 'Bearbetningsfeedback',
		'noCertificatesFoundTitle': 'Inga certifikat hittades',
		'noCertificatesFoundMessage': 'Vi kunde inte automatiskt hitta några säkerhetscertifikat. Vänligen ladda upp dina certifikat manuellt med hjälp av uppladdningssektionen nedan.',
		'gapAnalysisCheckbox': 'Jag har inga certifikat, men vill utföra en gap-analys',
		'gapAnalysisUploadTitle': 'Ladda upp gap-analys',
		'gapAnalysisUploadSubtitle': 'Vänligen ladda upp ditt ifyllda gap-analys dokument.',
		'gapAnalysisTemplateLink': 'Ladda ner gap-analys mall',
		'uploadDocument': 'Ladda upp dokument',
		'dropFileHere': 'Släpp filen här...',
		'dragDropFile': 'Dra och släpp en fil här eller klicka för att välja en fil',
		'uploading': 'Laddar upp',
		'uploadFailed': 'Uppladdningen misslyckades',
		'dismiss': 'Avvisa',
		'requiredDocumentsUploaded': 'Obligatoriska dokument',
		'optionalDocumentsUploaded': 'Valfria dokument',
		'otherDocumentsUploaded': 'Andra dokument',
		'recognizedAs': 'Igenkänd som',
		'aiProcessingSubtext': 'AI bearbetar ditt dokument',
		'uploadTitle': 'Validering och bristanalys',
		'analysisCompleteLabel': 'Analys slutförd',
		'summaryText': 'Du behöver {total}. {missing} saknas för närvarande i din profil.',
		'verifiedLabel': 'VERIFIERAD',
		'actionRequiredLabel': 'ÅTGÄRD KRÄVS',
		'uploadDocumentsSubtitle': 'Dra och släpp filer här eller klicka för att välja. Systemet identifierar automatiskt dokumenttypen.',
		'noDocumentsNeededTitle': 'Inga dokument krävs',
		'noDocumentsNeededMessage': 'Baserat på dina svar krävs inga ytterligare säkerhetscertifikat för denna arbetstyp.',
		'missingCertificationsAcknowledgment': 'Jag bekräftar de saknade certifieringarna och bekräftar att jag har giltiga tillfälliga papperskopior att uppvisa på plats.',
		'summaryTextAllComplete': 'Alla nödvändiga certifikat är tillgängliga.',
		'oneOfFollowingLabel': 'Ladda upp minst ett av följande:',
		'certificateSingular': 'certifikat',
		'certificatePlural': 'certifikat',
		'missingCountSingular': 'saknas',
		'missingCountPlural': 'saknas',
		'expiresLabel': 'UTGÅR',
		'orSeparator': ' eller '
	},
	'TR': {
		'yesLabel': 'Evet',
		'noLabel': 'Hayır',
		'intro': 'Site gereksinimlerine uyumu sağlamak için güvenlik sertifikalarınızı toplamamız gerekiyor. Bu süreç, niteliklerinizi doğrulamamıza ve sitede güvenli bir şekilde çalışabilmenizi sağlamamıza yardımcı olacaktır.',
		'userDetailsTitle': 'Lütfen bilgilerinizi sağlayın',
		'lblFirstName': 'Ad',
		'lblLastName': 'Soyad',
		'lblDOB': 'Doğum tarihi',
		'lblVAT': 'KDV numarası',
		'processingText': 'Güvenlik sertifikalarınız aranıyor...',
		'confirmationTitle': 'Güvenlik sertifikalarınızı gözden geçirin',
		'confirmationRequiredSubtitle': 'Aşağıdaki türler zorunludur: ',
		'confirmationRequiredSatisfied': 'Tüm gerekli belgeler sağlanmıştır',
		'confirmationOptionalSubtitle': 'Aşağıdaki türler isteğe bağlıdır: ',
		'foundCertificatesTitle': 'Bulunan sertifikalar',
		'foundCertificatesSubtitle': 'Aşağıdaki sertifikaları bulduk. Lütfen ilgili olmayan veya başka bir kişiye ait olanların seçimini kaldırın:',
		'uploadDocumentsTitle': 'Belgeleri yükle',
		'uploadedDocumentsSubtitle': 'Yüklediğiniz belgeleri gözden geçirin ve ilgili olmayanları kaldırın:',
		'noDocumentsCheckbox': 'Güvenlik sertifikası göndermeden devam etmek istediğimi ve bunun sitede çalışma yeteneğimi etkileyebileceğini anladığımı onaylıyorum.',
		'thankYouTitle': 'Gönderiminiz için teşekkürler',
		'thankYouText': 'Güvenlik sertifikalarınız gönderildi ve şimdi inceleme altında. Ek bilgi gerekirse sizinle iletişime geçeceğiz.',
		'removeDocument': 'Kaldır',
		'certificateNumber': 'Sertifika numarası',
		'certificateType': 'Sertifika türü',
		'certificateIssuer': 'Yayınlayan',
		'validUntil': 'Geçerlilik tarihi',
		'processingFeedback': 'İşleme geri bildirimi',
		'noCertificatesFoundTitle': 'Sertifika bulunamadı',
		'noCertificatesFoundMessage': 'Güvenlik sertifikalarını otomatik olarak bulamadık. Lütfen sertifikalarınızı aşağıdaki yükleme bölümünü kullanarak manuel olarak yükleyin.',
		'gapAnalysisCheckbox': 'Sertifikam yok ama bir boşluk analizi yapmak istiyorum',
		'gapAnalysisUploadTitle': 'Boşluk analizini yükle',
		'gapAnalysisUploadSubtitle': 'Lütfen doldurulmuş boşluk analizi belgenizi yükleyin.',
		'gapAnalysisTemplateLink': 'Boşluk analizi şablonunu indir',
		'uploadDocument': 'Belge yükle',
		'dropFileHere': 'Dosyayı buraya bırakın...',
		'dragDropFile': 'Bir dosyayı buraya sürükleyip bırakın veya dosya seçmek için tıklayın',
		'uploading': 'Yükleniyor',
		'uploadFailed': 'Yükleme başarısız',
		'dismiss': 'Reddet',
		'requiredDocumentsUploaded': 'Gerekli belgeler',
		'optionalDocumentsUploaded': 'İsteğe bağlı belgeler',
		'otherDocumentsUploaded': 'Diğer belgeler',
		'recognizedAs': 'Şu şekilde tanındı',
		'aiProcessingSubtext': 'AI belgenizi işliyor',
		'uploadTitle': 'Doğrulama ve boşluk analizi',
		'analysisCompleteLabel': 'Analiz tamamlandı',
		'summaryText': '{total} gerekli. {missing} şu anda profilinizde eksik.',
		'verifiedLabel': 'DOĞRULANDI',
		'actionRequiredLabel': 'İŞLEM GEREKLİ',
		'uploadDocumentsSubtitle': 'Dosyaları buraya sürükleyip bırakın veya seçmek için tıklayın. Sistem belge türünü otomatik olarak algılayacaktır.',
		'noDocumentsNeededTitle': 'Belge gerekmiyor',
		'noDocumentsNeededMessage': 'Yanıtlarınıza göre, bu iş türü için ek güvenlik sertifikası gerekmemektedir.',
		'missingCertificationsAcknowledgment': 'Eksik sertifikaları kabul ediyorum ve sahada sunmak üzere geçerli geçici kağıt kopyalara sahip olduğumu onaylıyorum.',
		'summaryTextAllComplete': 'Tüm gerekli sertifikalar mevcut.',
		'oneOfFollowingLabel': 'Aşağıdakilerden en az birini yükleyin:',
		'certificateSingular': 'sertifika',
		'certificatePlural': 'sertifika',
		'missingCountSingular': 'eksik',
		'missingCountPlural': 'eksik',
		'expiresLabel': 'SON KULLANMA',
		'orSeparator': ' veya '
	},
	'UK': {
		'yesLabel': 'Так',
		'noLabel': 'Ні',
		'intro': 'Нам потрібно зібрати ваші сертифікати безпеки, щоб забезпечити відповідність вимогам об\'єкта. Цей процес допоможе нам перевірити вашу кваліфікацію та забезпечити, що ви можете безпечно виконувати роботу на об\'єкті.',
		'userDetailsTitle': 'Будь ласка, надайте ваші дані',
		'lblFirstName': 'Ім\'я',
		'lblLastName': 'Прізвище',
		'lblDOB': 'Дата народження',
		'lblVAT': 'Номер ПДВ',
		'processingText': 'Пошук ваших сертифікатів безпеки...',
		'confirmationTitle': 'Перевірте ваші сертифікати безпеки',
		'confirmationRequiredSubtitle': 'Наступні типи є обов\'язковими: ',
		'confirmationRequiredSatisfied': 'Всі необхідні документи надано',
		'confirmationOptionalSubtitle': 'Наступні типи є опціональними: ',
		'foundCertificatesTitle': 'Знайдені сертифікати',
		'foundCertificatesSubtitle': 'Ми знайшли наступні сертифікати. Будь ласка, зніміть виділення з тих, які не є релевантними або належать іншій особі:',
		'uploadDocumentsTitle': 'Завантажити документи',
		'uploadedDocumentsSubtitle': 'Перевірте ваші завантажені документи та видаліть ті, які не є релевантними:',
		'noDocumentsCheckbox': 'Я підтверджую, що хочу продовжити без відправки сертифікатів безпеки і розумію, що це може вплинути на мою здатність виконувати роботу на об\'єкті.',
		'thankYouTitle': 'Дякуємо за вашу відправку',
		'thankYouText': 'Ваші сертифікати безпеки були відправлені і зараз проходять перевірку. Ми зв\'яжемося з вами, якщо знадобиться додаткова інформація.',
		'removeDocument': 'Видалити',
		'certificateNumber': 'Номер сертифіката',
		'certificateType': 'Тип сертифіката',
		'certificateIssuer': 'Видавець',
		'validUntil': 'Дійсний до',
		'processingFeedback': 'Зворотний зв\'язок з обробки',
		'noCertificatesFoundTitle': 'Сертифікати не знайдено',
		'noCertificatesFoundMessage': 'Ми не змогли автоматично знайти сертифікати безпеки. Будь ласка, завантажте ваші сертифікати вручну, використовуючи розділ завантаження нижче.',
		'gapAnalysisCheckbox': 'У мене немає сертифікатів, але я хочу провести аналіз прогалин',
		'gapAnalysisUploadTitle': 'Завантажити аналіз прогалин',
		'gapAnalysisUploadSubtitle': 'Будь ласка, завантажте ваш заповнений документ аналізу прогалин.',
		'gapAnalysisTemplateLink': 'Завантажити шаблон аналізу прогалин',
		'uploadDocument': 'Завантажити документ',
		'dropFileHere': 'Перетягніть файл сюди...',
		'dragDropFile': 'Перетягніть і відпустіть файл сюди або натисніть, щоб вибрати файл',
		'uploading': 'Завантаження',
		'uploadFailed': 'Завантаження не вдалося',
		'dismiss': 'Відхилити',
		'requiredDocumentsUploaded': 'Обов\'язкові документи',
		'optionalDocumentsUploaded': 'Опціональні документи',
		'otherDocumentsUploaded': 'Інші документи',
		'recognizedAs': 'Розпізнано як',
		'aiProcessingSubtext': 'ШІ обробляє ваш документ',
		'uploadTitle': 'Перевірка та аналіз прогалин',
		'analysisCompleteLabel': 'Аналіз завершено',
		'summaryText': 'Вам потрібно {total}. {missing} наразі відсутній у вашому профілі.',
		'verifiedLabel': 'ПЕРЕВІРЕНО',
		'actionRequiredLabel': 'ПОТРІБНА ДІЯ',
		'uploadDocumentsSubtitle': 'Перетягніть файли сюди або натисніть для вибору. Система автоматично визначить тип документа.',
		'noDocumentsNeededTitle': 'Документи не потрібні',
		'noDocumentsNeededMessage': 'На основі ваших відповідей для цього типу робіт не потрібні додаткові сертифікати безпеки.',
		'missingCertificationsAcknowledgment': 'Я визнаю відсутні сертифікати та підтверджую, що маю дійсні тимчасові паперові копії для пред\'явлення на об\'єкті.',
		'summaryTextAllComplete': 'Всі необхідні сертифікати доступні.',
		'oneOfFollowingLabel': 'Завантажте принаймні один із наступних:',
		'certificateSingular': 'сертифікат',
		'certificatePlural': 'сертифікатів',
		'missingCountSingular': 'відсутній',
		'missingCountPlural': 'відсутні',
		'expiresLabel': 'ЗАКІНЧУЄТЬСЯ',
		'orSeparator': ' або '
	},
};

export function getTextDefaults(lang) {
	return textDefaults[lang.toUpperCase()] || textDefaults.EN;
}

export function getLanguages() {
	return Object.keys(textDefaults);
}
